<template>
  <div class="page-container">
    <!-- 固定导航栏 -->
    <nav class="navbar" :class="{ 'navbar-fixed': isNavbarFixed, 'navbar-scrolled': isScrolled }">
      <div class="navbar-content">
        <div class="navbar-brand">
          <img src="./assets/img/FigmaDDSSlicePNG1f52009cf8f709682e81af452679a99e.png" alt="Logo" class="navbar-logo" />
          <span class="navbar-title">中广天择2026年高清连续多视角4D视频数据集</span>
        </div>
        <div class="navbar-menu">
          <a href="#home" class="navbar-item" @click.prevent="scrollToSection('home')">首页</a>
          <a href="#overview" class="navbar-item" @click.prevent="scrollToSection('overview')">数据概览</a>
          <!-- <a href="#annotation" class="navbar-item" @click.prevent="scrollToSection('annotation')">视频标注</a> -->
          <a href="#structure" class="navbar-item" @click.prevent="scrollToSection('structure')">数据集结构</a>
          <a href="#contact" class="navbar-item" @click.prevent="scrollToSection('contact')">联系我们</a>
          <a href="http://szzx.sjj.tvzone.cn/audio-viewData/index/" class="navbar-item" target="_blank">2026声学数据集</a>
          <a href="https://tvzone.cn/AI/index" class="navbar-item" target="_blank">中广天择数据产品全系列</a>
          <button class="navbar-btn-lang" @click="switchLanguage">English</button>
        </div>
      </div>
    </nav>

    <!-- 页面内容 -->
    <div class="page-content">
      <!-- 首页区域 -->
      <section id="home" class="section hero-section">
        <!-- 视频背景 -->
        <video class="hero-video" ref="heroVideo" autoplay muted loop playsinline>
          <source src="./assets/video/bg.mp4" type="video/mp4">
        </video>
        <div class="hero-overlay"></div>
        <div class="hero-content">
          <h1 class="hero-title">高清连续多视角4D视频数据集</h1>

          <p class="hero-subtitle">
            <span class="stat-line"> 多人动作<strong> 800+小时 </strong> | 双人动作 <strong> 2200+小时 </strong>| 单人动作 <strong> 7000+小时 </strong></span>
            <span class="stat-line"> 真实场景<strong> 2000+ </strong> · 人次拍摄 <strong> 6000+ </strong>  · 实拍总时长 <strong> 10000+小时 </strong> </span>
            <!-- <span class="stat-line">涵盖体育场馆、社区、家居、公园、消费场所、舞台演出等多类型室内外环境</span>
            <span class="stat-line">覆盖幼、青、中、老年全年龄段，捕捉年龄、体型、体能带来的真实动作差异</span> -->
            <span class="stat-line">“海量主体id × 复杂动作 × 多样场景” 多维度覆盖</span>
            <!-- <span class="stat-line">所有视频均为 1080p 高清连续拍摄，单段时长充足、时序信息连续、动作过程完整。</span> -->
            <span class="stat-line">全量1080p高清视频，动作连续，单段视频时长超60分钟。</span>
            <span class="feature-tagline">让你的模型理解时间、重建空间、捕捉动作</span>
          </p>

          <div class="hero-actions">
            <button class="btn btn-primary" @click="scrollToSection('overview')">
              <i class="icon">📄</i> 简介
            </button>
            <button class="btn btn-secondary" @click="playIntroVideo">
              <i class="icon">▶️</i> 介绍视频
            </button>
            <button class="btn btn-outline" @click="scrollToSection('data-details')">
              <i class="icon">📊</i> 数据详情
            </button>
          </div>

          <p class="hero-subtitle bottom">
            <span class="feature-tagline">高质量支撑：具身智能/视频模型/VR/AR/智能眼镜/……</span>
          </p>

        </div>
        <div class="scroll-indicator" @click="scrollToSection('overview')">
          <i class="icon">▼</i>
        </div>
      </section>

      <!-- 项目简介 -->
      <section id="overview" class="section overview-section">
        <div class="section-header">
          <h2 class="section-title">项目简介</h2>
        </div>
        <div class="overview-content">
          <div class="intro-text-section">
            <p class="intro-description">
              &nbsp;&nbsp;&nbsp;&nbsp;为攻克复杂人物交互与动态场景理解的关键瓶颈，中广天择基于2025年下半年的大规模生产，正式推出业界稀缺的1080P高清连续多视角4D视频数据集。
              <br>
              &nbsp;&nbsp;&nbsp;&nbsp;本数据集由我司自主生产并享有完整知识产权，凭借其全新的时效性、高体量与多维度的稀缺性，旨在填补国内外在真实、复杂、交互式人体动态数据领域的空白。
              <br>
              &nbsp;&nbsp;&nbsp;&nbsp;具有业界稀缺的全量1080P高清、每段长度充分（长达一小时的连续动作），多视角场景+人物动作的高质量数据集，高度适配于机器人、视频模型、VR、AR、智能眼镜等作为优质数据支撑。
            </p>

            <div class="intro-highlight-box">
              <!-- <h3 class="highlight-title">核心稀缺性与总量优势</h3> -->
              <div class="highlight-content">
                <div class="highlight-item">
                  <span class="highlight-text">体量大、数据新，定义行业新基准</span>
                  <p>
                    在动作数量（<span class="stat-highlight">50万+</span>）、主体id数量（<span class="stat-highlight">6000+</span>）与真实场景数（<span class="stat-highlight">2000+</span>）等核心维度上，
                    规模<span class="stat-highlight">百至千倍</span>超越国内外同类数据集。
                    数据集均为2025年下半年定制的实拍数据，确保数据的时效性与前沿性。
                  </p>
                </div>

                <div class="highlight-item">
                  <span class="highlight-text">攻克"昂贵"的动态交互采集难题</span>
                  <p>数据集深度聚焦最具价值的多人复杂交互动作（<span class="stat-highlight">超800小时</span>）与双人动作（<span class="stat-highlight">超2000小时</span>），以及单人动作（<span class="stat-highlight">超7000小时</span>），超过<span class="stat-highlight">6机位多视角同步采集系统</span>，全方位、无死角地捕捉人物主体的复杂空间关系与连续动作细节。</p>
                </div>

                <div class="highlight-item">
                  <span class="highlight-text">构建定义模型边界的多样性矩阵</span>
                  <p>数据覆盖从幼年到老年的<span class="stat-highlight">全年龄段人群</span>，并在运动场景、消费场景、家居场景等<span class="stat-highlight">多样化环境</span>中，系统性地采集并定义了道具类、动作类、互动类三大核心动作类别，实现<span class="stat-highlight">"人 × 场景 × 动作"</span>的三维立体覆盖，为模型理解从简单到复杂的人类行为提供了结构化基础。</p>
                </div>
              </div>
            </div>

            <div class="efficiency-section">
              <h3 class="section-subtitle">开箱即用，释放算法研发核心效能</h3>
              <p class="efficiency-description">
                通过贯穿采集、标注、质检全流程的工程化体系，本数据集实现了<span class="stat-highlight">多视角下海量人物动作的帧级对齐</span>与严格的质量控制。已完成所有的数据质检工作，确保数据交付即可直接投入使用。
              </p>

            </div>
          </div>

          <div class="feature-cards">
            <div class="feature-card">
              <div class="feature-icon"><img src="./assets/icon/Symbol1.svg" alt="Icon"></div>
              <h3>动作识别</h3>
              <!-- <p>高精度捕捉细微动作变化</p> -->
            </div>
            <div class="feature-card">
              <div class="feature-icon"><img src="./assets/icon/Symbol2.svg" alt="Icon"></div>
              <h3>三维重建</h3>
              <!-- <p>多视角数据支持高保真重建</p> -->
            </div>
            <div class="feature-card">
              <div class="feature-icon"><img src="./assets/icon/Symbol3.svg" alt="Icon"></div>
              <h3>多视角理解</h3>
              <!-- <p>6机位同步的全方位场景解析</p> -->
            </div>
          </div>
        </div>
      </section>

      <section id="data-details" class="section data-details-section">
        <div class="scene-diversity">
          <div class="scene-header">
            <div class="scene-header-left">
              <!-- <div class="h_1"></div> -->
              <div class="h_title">场景多样性 (Scene Diversity)</div>
              <p class="set-desc">更多数据详情点击右侧“更多”</p>
            </div>
            <button class="more-btn morebtn0" @click="goToMoreDetails">
              <div class="slide-track">
                    <span>更多</span>
                    <span>>>></span>
                </div>
            </button>
          </div>
          <div class="scene-images">
            <div class="scene-image coffee">
              <div class="action-header-tip">
                <span>室外场景拼图</span>
              </div>
              <img  class="camera-photo" src="./assets/img/outdoor.png" alt="">
              <!-- <video class="camera-video" ref="cameraVideo" autoplay muted loop playsinline>
                <source src="./assets/video/室内大堂拉伸.mp4" type="video/mp4">
              </video> -->
            </div>
            <div class="scene-image dance">
              <div class="action-header-tip">
                <span>室内场景拼图</span>
              </div>
              <img  class="camera-photo" src="./assets/img/indoor.png" alt="">
              <!-- <video class="camera-video" ref="cameraVideo" autoplay muted loop playsinline>
                <source src="./assets/video/室外教学楼爵士.mp4" type="video/mp4">
              </video> -->
            </div>
          </div>
        </div>

        <div class="action-grid">
          <div class="action-card">
            <div class="action-header">
              <span>单人动作 (Solo-action)</span>
              <span class="action-time">8000+小时</span>
              <button class="more-btn" @click="goToOneAct">更多</button>
            </div>
            <div class="action-preview">
              <div class="preview-placeholder">
                <div class="video-loading-overlay" :class="{ 'hidden': videoLoaded.solo }">
                  <span>视频加载中，请稍后</span>
                </div>
                <video class="camera-video" ref="cameraVideoSolo" autoplay muted loop playsinline @loadeddata="onVideoLoaded('solo')">
                  <source src="./assets/video/solo-action.mp4" type="video/mp4">
                </video>
              </div>
            </div>
          </div>

          <div class="action-card">
            <div class="action-header">
              <span>双人动作 (Two-action)</span>
              <span class="action-time">2000+小时</span>
              <button class="more-btn" @click="goToTwoAct">更多</button>
            </div>
            <div class="action-preview">
              <div class="preview-placeholder">
                <div class="video-loading-overlay" :class="{ 'hidden': videoLoaded.two }">
                  <span>视频加载中，请稍后</span>
                </div>
                <video class="camera-video" ref="cameraVideoTwo" autoplay muted loop playsinline @loadeddata="onVideoLoaded('two')">
                  <source src="./assets/video/two-action.mp4" type="video/mp4">
                </video>
              </div>
            </div>
          </div>

          <div class="action-card">
            <div class="action-header">
              <span>多人动作 (Multi-action)</span>
              <span class="action-time">800+小时</span>
              <button class="more-btn" @click="goToMultiAct">更多</button>
            </div>
            <div class="action-preview">
              <div class="preview-placeholder">
                <div class="video-loading-overlay" :class="{ 'hidden': videoLoaded.multi }">
                  <span>视频加载中，请稍后</span>
                </div>
                <video class="camera-video" ref="cameraVideoMulti" autoplay muted loop playsinline @loadeddata="onVideoLoaded('multi')">
                  <source src="./assets/video/multi-action.mp4" type="video/mp4">
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>


      <!-- 视频介绍 -->
      <section id="video-intro" class="section video-section">
        <div class="section-header">
          <h2 class="section-title">视频介绍</h2>
        </div>
        <div class="video-player">
          <div class="video-container">
            <!-- 视频元素 -->
            <video
              ref="introVideo"
              class="intro-video"
              loop
              @loadedmetadata="onVideoLoaded"
              @timeupdate="onTimeUpdate"
              @ended="onVideoEnded"
              @click="togglePlayPause"
            >
              <source src="./assets/video/intro_video.mp4" type="video/mp4">
              您的浏览器不支持视频播放。
            </video>

            <!-- 播放按钮覆盖层（视频未播放时显示） -->
            <div class="video-overlay" v-if="!isPlaying">
              <button class="play-button" @click="playVideo">
                <span>▶</span>
              </button>
            </div>

            <!-- 视频控制栏 -->
            <div class="video-controls" v-if="showControls">
              <div class="logo-tag">中广天择</div>
              <div class="progress-bar" @click="seekVideo">
                <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
              </div>
              <div class="control-buttons">
                <button class="control-btn" @click="togglePlayPause">
                  {{ isPlaying ? '⏸️' : '▶️' }}
                </button>
                <div><img src="./assets/img/FigmaDDSSlicePNG1f52009cf8f709682e81af452679a99e.png" alt="icon"></div>
                <span class="time-display">{{ currentTime }} / {{ duration }}</span>
                <button class="control-btn" @click="toggleMute">
                  {{ isMuted ? '🔇' : '🔊' }}
                </button>
                <button class="control-btn" @click="toggleFullscreen">⛶</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 数据概览 -->
      <section id="data-details" class="section data-overview-section">
        <div class="section-header">
          <div class="section-title-group">
            <img src="./assets/img/FigmaDDSSlicePNG08e268df1e0d3e6c78d49be8ccdaf359.png" alt="" class="section-icon" />
            <h2 class="section-title">数据概览</h2>
            <span class="badge">国内独有</span>
          </div>
          <!-- <p class="section-subtitle">基于多维度参数的行业竞品分析</p> -->
        </div>

        <div class="section-content">

          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon"><img src="./assets/icon/dataIcon1.svg" alt="Icon"></div>

              <div class="stat-value-label-wrapper">
                <div class="stat-value-label">
                  <div class="stat-value-container">
                    <span class="stat-value">10000+</span>
                    <span class="stat-unit">小时</span>
                  </div>
                  <div class="stat-label">总时长</div>
                </div>
              </div>

              <div class="stat-detail  detail1">全量1080p</div>
            </div>
          </div>

          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon2"><img src="./assets/icon/dataIcon2.svg" alt="Icon"></div>

              <div class="stat-value-label-wrapper">
                <div class="stat-value-label">
                  <div class="stat-value-container">
                    <div class="stat-value">2000+</div>
                    <span class="stat-unit">个</span>
                  </div>
                  <div class="stat-label">场景</div>
                </div>

                <div class="stat-value-label">
                  <div class="stat-value-container">
                    <div class="stat-value">6000+</div>
                    <span class="stat-unit">个</span>
                  </div>
                  <div class="stat-label">ID数</div>
                </div>
              </div>

              <div class="stat-detail detail2">真实场景</div>
            </div>

          </div>

          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon3"><img src="./assets/icon/dataIcon3.svg" alt="Icon"></div>

              <div class="stat-value-label-wrapper">
                <div class="stat-value-label">
                  <div class="stat-value-container">
                    <div class="stat-value">50W+</div>
                    <span class="stat-unit">个</span>
                  </div>
                  <div class="stat-label">单一主体动作</div>
                </div>

                <div class="stat-value-label">
                  <div class="stat-value-container">
                    <div class="stat-value">3W+</div>
                    <span class="stat-unit">个</span>
                  </div>
                  <div class="stat-label">不同复杂动作</div>
                </div>
              </div>

              <div class="stat-detail detail3">场景动作强相关</div>
            </div>
          </div>

          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon4"><img src="./assets/icon/dataIcon4.svg" alt="Icon"></div>

              <div class="stat-value-label-wrapper">
                <div class="stat-value-label3">
                  <div class="stat-value-container">
                    <div class="stat-value">7k+</div>
                  </div>
                  <div class="stat-label">单人时长(h)</div>
                </div>

                <div class="stat-value-label3">
                  <div class="stat-value-container">
                    <div class="stat-value">2.2k+</div>
                  </div>
                  <div class="stat-label">双人时长(h)</div>
                </div>

                <div class="stat-value-label3">
                  <div class="stat-value-container">
                    <div class="stat-value">0.8k+</div>
                  </div>
                  <div class="stat-label">多人时长(h)</div>
                </div>
              </div>

              <div class="stat-detail detail4">多人群覆盖</div>
            </div>
          </div>

        </div>

        <!-- 动作集 -->
        <div class="action-set-container">
          <div class="action-set-header">
            <img src="../lanhu_frame_1/assets/img/FigmaDDSSlicePNG80d4fcca1a86c1f9514cbac4deb6ee59.png" alt="" class="action-icon" />
            <h3>动作集 (Action Set)</h3>
          </div>
          <p class="action-set-desc">对4334小时动作进行抽样整理。此处显示了相应场景中的动作集概览。块大小代表相应的动作时长。</p>

          <div class="action-visualization">
            <div class="viz-box" style="flex: 1 1 100%; min-width: 100%;">
              <div class="viz-header">
                <img src="../lanhu_frame_1/assets/img/FigmaDDSSlicePNG1c14ab2797a5b77846a692a28306c6d5.png" alt="" class="viz-thumbnail" />
                <span class="viz-text" @click="openFullscreenChart" style="cursor: pointer;">交互式场景动作数据可视化 (Sunburst Chart)</span>
              </div>
              <div class="plotly-container">
                <div id="plotly-action-viz" style="width: 100%; height: 500px;"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="feature-boxes">
          <div class="feature-box">
            <div class="box-header">
              <div class="box-icon"><img src="./assets/icon/box-icon1.svg" alt="Icon"></div>
              <h3>多视角帧对齐</h3>
            </div>
            <p class="box-description">
              采用了精准的同步技术，确保不同机位拍摄的画面在同一时间点完全对齐。通过对每个画面进行精确的时间标定，避免了拍摄过程中的时间偏差，确保在多视角下的数据一致性。
            </p>
            <div class="box-tags">
              <span class="tag">多机位</span>
              <span class="tag">25 FPS</span>
            </div>
          </div>

          <div class="feature-box">
            <div class="box-header">
              <div class="box-icon"><img src="./assets/icon/box-icon2.svg" alt="Icon"></div>
              <h3>抽帧建模匹配</h3>
            </div>
            <p class="box-description">
              通过对每段数据进行精细处理，提取关键帧来精确匹配人物和环境，确保画面在整个过程中不会发生任何扭曲或变形，最大程度上保证每段数据的清晰度和质量。
            </p>
            <div class="box-tags tags2">
              <span class="tag">SMPL-X</span>
              <span class="tag">3D Mesh</span>
            </div>
          </div>

          <div class="feature-box">
            <div class="box-header">
              <h3>数据分布占比</h3>
              <!-- <button class="more-btn" @click="goToMoreDetails">更多</button> -->
            </div>

            <div class="distribution-chart">
              <div class="pie-chart"></div>
              <div class="chart-legend">
                <div class="legend-item">
                  <span class="legend-color single"></span>
                  <span>单人动作 70%</span>
                </div>
                <div class="legend-item">
                  <span class="legend-color double"></span>
                  <span>双人动作 22%</span>
                </div>
                <div class="legend-item">
                  <span class="legend-color multi"></span>
                  <span>多人动作 8%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 对比表格 -->
        <div class="comparison-table">
          <div class="table-header">
            <div class="w_first">
              <div class="w_1"></div>
              <div class="w_title">主流3D人体数据集参数对比</div>
            </div>
            <div class="legend">
              <div class="l_dot1"></div>
              <div class="legend-item our">本数据集</div>
              <div class="l_dot2"></div>
              <div class="legend-item other">其他</div>
            </div>
          </div>
          <div class="table-content">
            <div class="table-row header">
              <span>数据集</span>
              <span>环境</span>
              <span>场景</span>
              <span>时长</span>
              <!-- <span>帧率</span> -->
              <span>人次</span>
              <span>单条时长</span>
            </div>
            <div class="table-row" v-for="(item, index) in comparisonData" :key="index" :class="{ highlight: item.isOurs }">
              <span :class="{ 'our-text': item.isOurs }">
                <span>{{ item.name }}</span>
                <span class="camera-tag" :class="item.isFixed ? 'fixed' : 'movable'">
                  {{ item.isFixed ? '固定镜头' : '移动镜头' }}
                </span>
              </span>
              <span :class="['env-badge', item.environment === '真实场景' ? 'real-world' : 'lab']">{{ item.environment }}</span>
              <span>{{ item.scenes }}</span>
              <span :class="{ 'our-text': item.isOurs }">{{ item.duration }}</span>
              <!-- <span>{{ item.fps }}</span> -->
              <span>{{ item.people }}</span>
              <span>{{ item.one_min }}</span>
            </div>
          </div>

          <div class="note-box">
            <div class="note-header">
              <!-- <span>† 说明:</span> -->
              <span>† 说明:中广天择高清连续多视角4D视频数据集严格采用横屏、1080p、25fps的统一标准采集，多数单条视频时长超过60分钟，在各维度均实现了数量级跨越，能够完整覆盖从简单到复杂的动作体系。</span>
            </div>
            <!-- <div class="note-footer">
              <span>可移动的，摄像机姿态在不同的视频序列中会发生变化。</span>
            </div> -->
          </div>
        </div>
      </section>

      <!-- 视频标注 -->
      <!-- <section id="annotation" class="section annotation-section">
        <div class="section-header">
          <h2 class="section-title">视频标注</h2>
        </div>
        <div class="annotation-content">
          <div class="annotation-card">
            <h3>多ID场景对比</h3>
            <div class="id-grid">
              <div class="id-item">ID_001</div>
              <div class="id-item">ID_002</div>
              <div class="id-item">ID_003</div>
              <div class="id-item">ID_004</div>
            </div>
            <p class="annotation-desc">
              在完全一致的光照与背景下，通过更换不同ID（演员）来丰富数据集的多样性。
            </p>
          </div>

          <div class="annotation-card">
            <h3>3D SMPL 标注可视化</h3>
            <div class="smpl-view">
              <span>🔧 3D Skeleton View</span>
            </div>
            <p class="annotation-desc">
              提供每一帧的高精度3D人体网格标注，支持骨骼点检测与姿态估计。
            </p>
          </div>
        </div>
      </section> -->

      <!-- 数据集结构 -->
      <section id="structure" class="section structure-section">
        <div class="section-header">
          <h2 class="section-title">数据集结构</h2>
          <p class="action-str-desc">我们提供可模块化选择的标注数据，覆盖从视频级到帧级的人体参数。
            <br>可根据实际需求，自由选择所需字段：多机位原始视频数据、环境、场景类型、人数、动作类别、时长、点云数据（.vgt）、帧级人体参数（SMPL）</p>
        </div>
        <div class="structure-content">
          <div class="file-header">
            <span>📄 dataset_structure_preview.txt</span>
          </div>
          <div class="tree-view">
            <div class="tree-line">├── Dataset_Root/</div>
            <div class="tree-line">│   ├── Videos/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;# 原始视频数据</div>
            <div class="tree-line">│   │   ├── Duration/&nbsp;&nbsp;&nbsp;&nbsp; # 时长</div>
            <div class="tree-line">│   │   ├── Scene_01/&nbsp;&nbsp;&nbsp;&nbsp; # 一个完整采集单元</div>
            <div class="tree-line">│   │   │   ├── Cam_01.mp4</div>
            <div class="tree-line">│   │   │   └── ... (6 views)</div>
            <div class="tree-line">│   ├── Content/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; # 场景内容描述</div>
            <div class="tree-line">│   │   ├── Environment/&nbsp;&nbsp;&nbsp;# 环境</div>
            <div class="tree-line">│   │   ├── Scene_Type/&nbsp;&nbsp;&nbsp; # 场景</div>
            <div class="tree-line">│   │   ├── People_Count/&nbsp;&nbsp; # 人数</div>
            <div class="tree-line">│   │   ├── Action_Category/&nbsp;# 动作</div>
            <div class="tree-line">│   ├── VGGT/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; # 3D点云图</div>
            <div class="tree-line">│   ├── Annotations/&nbsp;&nbsp;&nbsp;&nbsp; # SMPL 参数</div>
            <div class="tree-line">│   │   ├── Scene_01.json</div>
            <div class="tree-line">│   │   │   ├── "frames": [</div>
            <div class="tree-line">│   │   │   │   ├──{</div>
            <div class="tree-line">│   │   │   │   │   ├── "frame_id": 0,</div>
            <div class="tree-line">│   │   │   │   │   ├── "smpl_params": {</div>
            <div class="tree-line">│   │   │   │   │   │   ├── "global_orient": [rx, ry, rz], </div>
            <div class="tree-line">│   │   │   │   │   │   ├── "body_pose": [[j1_rx, j1_ry, j1_rz],...], # 共23个关节</div>
            <div class="tree-line">│   │   │   │   │   │   ├── "transl": [tx, ty, tz], </div>
            <div class="tree-line">│   │   │   │   │   ├── }</div>
            <div class="tree-line">│   │   │   │   ├──}</div>
            <div class="tree-line">│   │   │   ├──]</div>
          </div>
          <!-- <div class="compliance-notice">
            <span>⚠</span>
            <span>使用本数据集需遵循商业合规协议</span>
          </div> -->
          <!-- <button class="download-btn" @click="downloadDocument">下载完整文档说明</button> -->
        </div>
      </section>

      <!-- 产品链接独立区域 -->
      <div style="width:96%;max-width:1340px;margin:0 auto 48px;text-align:center;padding:24px;background:#0f172a;border-radius:8px;box-sizing:border-box;">
        <a href="https://tvzone.cn/AI/index" target="_blank" style="display:inline-block;text-decoration:none;cursor:pointer;">
          <span style="color:#60a5fa;font-size:28px;font-weight:bold;">中广天择数据产品全系列产品官网</span>
          <svg style="vertical-align:middle;margin-left:8px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#60a5fa" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"/><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"/><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>        </a>
        <a href="https://tvzone.cn/AI/index" target="_blank" style="display:inline-block;margin-left:12px;color:#94a3b8;font-size:14px;text-decoration:none;cursor:pointer;">欢迎点击进入详情页观览</a>
      </div>

      <!-- 联系我们 -->
      <section id="contact" class="section contact-section">
        <div class="contact-content">
          <div class="contact-info">
            <h3>欢迎联系我们获取更多技术细节、沟通合作</h3>
            <div class="contact-item">
              <span>🏃‍♂️‍➡️</span>
              <span>中广天择传媒股份有限公司-数智中心</span>
            </div>
            <div class="contact-item">
              <div class="contact-address">聚焦高质量音视频算法训练语料的规模化研发、生产、运营交付等全链路
                <br> 成熟支撑国内多家顶尖科技公司的训练与场景化落地应用</div>
            </div>
            <div class="contact-item">
              <span>📧</span>
              <span>电子邮件</span>
            </div>
            <div class="contact-item">
              <div class="contact-address">szzx@tvzone.cn</div>
            </div>
            <div class="contact-item feishu-item">
              <span>💬</span>
              <span>加上飞书直接聊（请注明来意）</span>
            </div>
            <div class="contact-item">
              <img src="./assets/img/tongna.png" alt="飞书二维码" class="feishu-qr feishu-qr-small" @click="expandFeishuQR">
            </div>
            <div class="contact-item">
              <span>📍</span>
              <span>地址</span>
            </div>
            <div class="contact-address">湖南省长沙市开福区月湖街道鸭子铺路46号中广天择总部基地</div>            <!-- <div class="contact-links"> -->
              <!-- <span>资源链接</span>
              <div class="link-group">
                <a href="#" class="link-item">GitHub Repo</a>
                <a href="#" class="link-item">集团主页</a>
                <a href="#" class="link-item">FreeMan API</a>
              </div> -->
            <!-- </div> -->
          </div>
          <div class="contact-qr">
            <!-- QR码占位 -->
            <img class="address-img" src="./assets/img/Address.png" alt="img">
          </div>
        </div>
        <div class="footer">
          <p>© 2026 中广天择高清连续多视角4D视频数据集. All rights reserved.</p>
        </div>
      </section>
    </div>

    <!-- 联系我们弹窗 -->
    <div class="modal-overlay" :class="{ 'modal-active': showContactModal }" @click="closeContactModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <div class="modal-title-wrapper">
<!--            <h3 class="modal-title">让我们联系您</h3>-->
<!--            <img src="./assets/img/tongna.png" alt="联系我们" class="modal-image">-->
          </div>
          <button class="modal-close" @click="closeContactModal">×</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitContactForm">
            <div class="form-group">
              <label class="form-label">
                <span class="label-icon">👤</span>
                姓名
              </label>
              <input
                  v-model="contactForm.name"
                  type="text"
                  class="form-input"
                  placeholder="请输入您的姓名"
              >
            </div>

<!--            <div class="form-group">-->
<!--              <label class="form-label">性别</label>-->
<!--              <div class="radio-group">-->
<!--                <label class="radio-item">-->
<!--                  <input-->
<!--                      type="radio"-->
<!--                      v-model="contactForm.gender"-->
<!--                      value="男"-->
<!--                      name="gender"-->
<!--                  >-->
<!--                  <span>男</span>-->
<!--                </label>-->
<!--                <label class="radio-item">-->
<!--                  <input-->
<!--                      type="radio"-->
<!--                      v-model="contactForm.gender"-->
<!--                      value="女"-->
<!--                      name="gender"-->
<!--                  >-->
<!--                  <span>女</span>-->
<!--                </label>-->
<!--              </div>-->
<!--            </div>-->

            <div class="form-group">
              <label class="form-label">
                <span class="label-icon">📱</span>
                联系电话
              </label>
              <input
                  v-model="contactForm.phone"
                  type="tel"
                  class="form-input"
                  placeholder="请输入您的联系电话"
              >
            </div>

            <div class="form-group">
              <label class="form-label">
                <span class="label-icon">🏢</span>
                公司名称
              </label>
              <input
                  v-model="contactForm.company"
                  type="text"
                  class="form-input"
                  placeholder="请输入您的公司名称"
              >
            </div>

            <div class="form-group">
              <label class="form-label">
                <span class="label-icon">✉️</span>
                工作邮箱
              </label>
              <input
                  v-model="contactForm.email"
                  type="text"
                  class="form-input"
                  placeholder="请输入您的工作邮箱"
              >
            </div>

            <div class="form-group">
              <label class="form-label">
                <span class="label-icon"></span>
                职位
              </label>
              <input
                  v-model="contactForm.position"
                  type="text"
                  class="form-input"
                  placeholder="请输入您的职位"
              >
            </div>

            <div class="form-group">
              <textarea
                  v-model="contactForm.message"
                  class="form-textarea"
                  placeholder="请详细描述您的需求、数据集规模以及预期效果，我们会尽快回复您。"
                  rows="4"
              ></textarea>
            </div>

<!--            <div class="submit-image-wrapper">-->
<!--              <img src="./assets/img/tongna.png" alt="提交" class="submit-image">-->
<!--            </div>-->

            <button type="submit" class="submit-btn">提交</button>
          </form>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
<!--    <div class="image-preview-overlay" :class="{ 'preview-active': showPreview }" @click="closeImagePreview">-->
<!--      <div class="image-preview-content" @click.stop>-->
<!--        <button class="preview-close" @click="closeImagePreview">×</button>-->
<!--        <img src="./assets/img/tongna.png" alt="预览" class="preview-image">-->
<!--      </div>-->
<!--    </div>-->


    <!-- 飞书二维码预览弹窗 -->
    <div class="feishu-preview-overlay" :class="{ 'feishu-preview-active': showFeishuPreview }" @click="closeFeishuPreview">
      <div class="feishu-preview-content" @click.stop>
        <button class="feishu-preview-close" @click="closeFeishuPreview">×</button>
        <img src="./assets/img/tongna.png" alt="飞书二维码" class="feishu-preview-image">
      </div>
    </div>
    <!-- 右侧悬浮栏 -->
    <div class="floating-sidebar">
      <!-- 飞书按钮 -->
<!--      <div-->
<!--          class="sidebar-item sidebar-item-top"-->
<!--          id="feishu-btn"-->
<!--      >-->
<!--        <div class="sidebar-icon">-->
<!--          <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">-->
<!--            <path d="M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm7 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM12 2C6.48 2 2 6 2 11c0 2.76 1.38 5.26 3.59 6.93L5 22l4.64-2.32A10.9 10.9 0 0 0 12 20c5.52 0 10-4 10-9S17.52 2 12 2z"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span class="sidebar-label">飞书</span>-->
<!--      </div>-->

<!--      &lt;!&ndash; 分隔线 &ndash;&gt;-->
<!--      <div class="sidebar-divider"></div>-->

      <!-- 邮箱按钮 -->
<!--      <div-->
<!--          class="sidebar-item sidebar-item-email"-->
<!--          id="email-btn"-->
<!--      >-->
<!--        <div class="sidebar-icon">-->
<!--          <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">-->
<!--            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span class="sidebar-label">邮件</span>-->
<!--      </div>-->
    </div>





  </div>
</template>

<script>
export default {
  name: 'LanhuFrame',
  data() {
    return {
      isNavbarFixed: false,
      isScrolled: false,
      plotlyLoaded: false,
      showContactModal: false,
      showFeishuTip: false,
      showEmailTip: false,
      showFeishuPreview: false,
      contactForm: {
        name: '',
        gender: '',
        phone: '',
        company: '',
        email: '',
        position: '',
        message: ''
      },
      videoLoaded: {
        solo: false,
        two: false,
        multi: false
      },
      plotlyData: {
        branchvalues: "total",
        customdata: [["办公楼"], ["办公楼"], ["办公楼"], ["办公楼"], ["办公室"], ["玻璃门前空地"], ["大厅"], ["电竞室"], ["雕塑室"], ["多屏幕室内训练馆"], ["工作室"], ["公司活动室"], ["功能室"], ["广播录播室"], ["化妆间"], ["画室"], ["会议室"], ["机械仓库"], ["健身房"], ["酒店大厅"], ["剧场"], ["客厅"], ["客厅"], ["客厅"], ["客厅沙发前"], ["客厅沙发前"], ["林荫道"], ["录音棚"], ["录音棚"], ["毛坯房内"], ["美术室"], ["喷泉前空地"], ["器材仓库"], ["烧烤摊摊车前"], ["摄影棚"], ["摄影棚"], ["室内运动场所"], ["书房"], ["台球室"], ["跳蚤市场"], ["跳蚤市场"], ["亭院"], ["亭院"], ["投影舞台"], ["图书馆"], ["图书馆"], ["卧室"], ["卧室"], ["卧室"], ["舞蹈练习室"], ["舞蹈室"], ["舞蹈室"], ["舞蹈室"], ["新闻联播室"], ["休息室"], ["休闲活动区"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["操作室"], ["养生健身室"], ["摇滚工作室"], ["艺术室"], ["音乐厅"], ["瑜伽室"], ["运动器材室"], ["杂货间"], ["杂货间"], ["杂货间"], ["展览馆"], ["展厅"], ["展映海报旁"], ["展映室"], ["直播室"], ["直播室"], ["直播室"], ["直播室"], ["直播室"], ["直播室"], ["直播室"], ["直播室"], ["直播室"], ["直播室"], ["玻璃墙旁"], ["玻璃墙旁"], ["玻璃墙旁"], ["草丛边空地"], ["草丛边空地"], ["草坪"], ["草坪"], ["草坪"], ["草坪"], ["草坪"], ["草坪"], ["草坪"], ["草坪"], ["草坪"], ["道路区域"], ["道路区域"], ["道路区域"], ["道路区域"], ["道路区域"], ["地下商城"], ["公共健身区"], ["公司楼下大坪"], ["公园步道"], ["公园步道"], ["公园草地"], ["公园花坛"], ["公园花坛"], ["公园健身"], ["公园围墙边"], ["公园休息区"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["广场"], ["红砖休息亭"], ["户外活动区"], ["花坛"], ["活动区"], ["健身房"], ["篮球场"], ["篮球场"], ["篮球场"], ["篮球场"], ["篮球场"], ["林荫道"], ["林荫小道"], ["马路旁"], ["毛坯商铺"], ["乒乓球场"], ["人行道"], ["社区凉亭旁"], ["升旗台"], ["室内体育馆"], ["室外空地"], ["树林"], ["树林"], ["树荫通道"], ["树荫下空地"], ["树荫下空地"], ["树荫下空地"], ["宿舍楼间通道"], ["宿舍楼前停车区域"], ["塑胶运动场"], ["田径场"], ["田径场"], ["田径场"], ["停车场"], ["网球场"], ["小区晨练场所"], ["小区楼下"], ["小区楼下"], ["小区楼下"], ["小区楼下空地"], ["小区楼下空地"], ["小区楼下空地"], ["小区乒乓球台"], ["小区乒乓球台"], ["小区羽毛球场"], ["小区羽毛球场"], ["操作室"], ["操作室"], ["操作室后"], ["训练场"], ["训练场"], ["训练场"], ["夜市"], ["夜市"], ["羽毛球场"], ["栅栏前空地"], ["柱廊间空地"], ["柱廊间空地"], ["走廊"], ["走廊"], ["走廊"], ["走廊"], ["走廊"], ["走廊"], ["走廊"], ["走廊"], ["走廊"], ["足球场"], ["办公楼"], ["办公室"], ["玻璃门前空地"], ["大厅"], ["电竞室"], ["雕塑室"], ["多屏幕室内训练馆"], ["工作室"], ["公司活动室"], ["功能室"], ["广播录播室"], ["化妆间"], ["画室"], ["会议室"], ["机械仓库"], ["健身房"], ["酒店大厅"], ["剧场"], ["客厅"], ["客厅沙发前"], ["林荫道"], ["录音棚"], ["毛坯房内"], ["美术室"], ["喷泉前空地"], ["器材仓库"], ["烧烤摊摊车前"], ["摄影棚"], ["室内运动场所"], ["书房"], ["台球室"], ["跳蚤市场"], ["亭院"], ["投影舞台"], ["图书馆"], ["卧室"], ["舞蹈练习室"], ["舞蹈室"], ["新闻联播室"], ["休息室"], ["休闲活动区"], ["操作室"], ["养生健身室"], ["摇滚工作室"], ["艺术室"], ["音乐厅"], ["瑜伽室"], ["运动器材室"], ["杂货间"], ["展览馆"], ["展厅"], ["展映海报旁"], ["展映室"], ["直播室"], ["玻璃墙旁"], ["草丛边空地"], ["草坪"], ["道路区域"], ["地下商城"], ["公共健身区"], ["公司楼下大坪"], ["公园步道"], ["公园草地"], ["公园花坛"], ["公园健身"], ["公园围墙边"], ["公园休息区"], ["广场"], ["红砖休息亭"], ["户外活动区"], ["花坛"], ["活动区"], ["健身房"], ["篮球场"], ["林荫道"], ["林荫小道"], ["马路旁"], ["毛坯商铺"], ["乒乓球场"], ["人行道"], ["社区凉亭旁"], ["升旗台"], ["室内体育馆"], ["室外空地"], ["树林"], ["树荫通道"], ["树荫下空地"], ["宿舍楼间通道"], ["宿舍楼前停车区域"], ["塑胶运动场"], ["田径场"], ["停车场"], ["网球场"], ["小区晨练场所"], ["小区楼下"], ["小区楼下空地"], ["小区乒乓球台"], ["小区羽毛球场"], ["操作室"], ["操作室后"], ["训练场"], ["夜市"], ["羽毛球场"], ["栅栏前空地"], ["柱廊间空地"], ["走廊"], ["足球场"], ["室内"], ["室外"]],
        ids: ["室内/办公楼/翻阅书本", "室内/办公楼/使用办公道具操作", "室内/办公楼/动态拉伸操", "室内/办公楼/双人摆pose", "室内/办公室/复习功课", "室内/玻璃门前空地/日常运动", "室内/大厅/使用乒乓球", "室内/电竞室/发放宣传单", "室内/雕塑室/健身操视频跟练", "室内/多屏幕室内训练馆/武术", "室内/工作室/使用浇花器", "室内/公司活动室/多人网球训练", "室内/功能室/跳舞", "室内/广播录播室/打闹互动", "室内/化妆间/使用办公场景道具", "室内/画室/摆放雕像", "室内/会议室/脖颈运动", "室内/机械仓库/吃零食", "室内/健身房/使用胶带", "室内/酒店大厅/日常运动", "室内/剧场/使用黑板刷", "室内/客厅/家庭唱K", "室内/客厅/清理垃圾", "室内/客厅/使用扇子", "室内/客厅沙发前/使用鸡毛掸子", "室内/客厅沙发前/客厅阅读", "室内/林荫道/身体不舒服", "室内/录音棚/使用杠铃", "室内/录音棚/使用钢琴", "室内/毛坯房内/单人拉丁舞", "室内/美术室/绘画教学", "室内/喷泉前空地/关节运动", "室内/器材仓库/佩戴遮阳帽", "室内/烧烤摊摊车前/聚会烧烤", "室内/摄影棚/使用采访脚本", "室内/摄影棚/使用手提包", "室内/室内运动场所/登山跑", "室内/书房/清理维护书房", "室内/台球室/操作台球台", "室内/跳蚤市场/翻看商品手册", "室内/跳蚤市场/使用爱心箱", "室内/亭院/打理花草", "室内/亭院/打扫庭院", "室内/投影舞台/舞台剧剧目表演", "室内/图书馆/使用软尺", "室内/图书馆/跟视频学习舞蹈", "室内/卧室/使用马克笔", "室内/卧室/房间内跳操", "室内/卧室/枕头大战", "室内/舞蹈练习室/京剧表演", "室内/舞蹈室/采访脚本", "室内/舞蹈室/搬运行李箱", "室内/舞蹈室/视频学习街舞舞蹈", "室内/新闻联播室/使用筹码盒", "室内/休息室/使用岛台", "室内/休闲活动区/双人台球对打", "室内/操作室/查看彩票", "室内/操作室/大扫除", "室内/操作室/订书机、文件盒", "室内/操作室/读书、听音乐、写日记", "室内/操作室/粉笔擦+粉笔", "室内/操作室/记录记账本", "室内/操作室/剪纸", "室内/操作室/模拟羽毛球训练", "室内/操作室/泡泡面", "室内/操作室/佩戴棒球帽", "室内/操作室/拼搭积木", "室内/操作室/上课", "室内/操作室/摄影补光灯", "室内/操作室/使用杯子", "室内/操作室/使用餐巾纸", "室内/操作室/使用充电器", "室内/操作室/使用耳机", "室内/操作室/使用高尔夫球杆", "室内/操作室/使用购物袋", "室内/操作室/使用化妆刷", "室内/操作室/使用键盘", "室内/操作室/使用卡片", "室内/操作室/使用毛线团", "室内/操作室/使用签名笔", "室内/操作室/使用扫把", "室内/操作室/使用小风扇", "室内/操作室/使用颜料盘", "室内/操作室/使用指甲刀", "室内/操作室/踢毽子", "室内/操作室/挑选面包", "室内/操作室/玩玩偶挂件", "室内/操作室/洗抹布", "室内/操作室/演讲稿", "室内/操作室/整理物品", "室内/操作室/整理玩偶挂件", "室内/操作室/整理文件", "室内/操作室/整理文具袋", "室内/操作室/装文件袋", "室内/操作室/开门广播体操", "室内/操作室/跳舞、锻炼", "室内/操作室/八段锦", "室内/操作室/八段锦、拉伸", "室内/操作室/闭眼许愿", "室内/操作室/表演话剧", "室内/操作室/发呆", "室内/操作室/复古舞蹈", "室内/操作室/画前准备", "室内/操作室/基础队列动作", "室内/操作室/健身操", "室内/操作室/健身等", "室内/操作室/脚部运动", "室内/操作室/啦啦操", "室内/操作室/男团舞", "室内/操作室/热身准备", "室内/操作室/手部运动、腿部运动、肩部运动", "室内/操作室/手写祝福", "室内/操作室/体操训练", "室内/操作室/跳跃", "室内/操作室/舞蹈基本功训练", "室内/操作室/学手语、拍抖音", "室内/操作室/眼保健操", "室内/操作室/远望", "室内/操作室/早操", "室内/操作室/宅舞", "室内/操作室/真人CS情景演绎", "室内/操作室/整理仪容仪表", "室内/操作室/转头拉伸", "室内/操作室/使用大提琴", "室内/操作室/多人舞蹈", "室内/操作室/歌朗诵", "室内/操作室/广场舞", "室内/操作室/街舞舞蹈学习", "室内/操作室/课间嬉戏打闹", "室内/操作室/少儿舞蹈教学", "室内/操作室/手势舞", "室内/操作室/团体舞", "室内/操作室/玩游戏", "室内/操作室/知识问答", "室内/操作室/电脑协作体验", "室内/操作室/快递取放", "室内/操作室/使用泡泡机", "室内/操作室/双人交谈场景", "室内/操作室/帮背书", "室内/操作室/表演才艺", "室内/操作室/放松身体", "室内/操作室/古法健身", "室内/操作室/肩颈保健操", "室内/操作室/拉伸、坐姿运动", "室内/操作室/模仿游戏", "室内/操作室/平衡协调互动", "室内/操作室/双人打闹", "室内/操作室/双人舞教学、双人减脂舞", "室内/操作室/跳舞，拉伸", "室内/操作室/同台竞演", "室内/操作室/玩舞蹈游戏", "室内/操作室/演唱会舞台唱歌表演", "室内/操作室/主持人讲话", "室内/操作室/做普拉提", "室内/操作室/双人交互类收碗与饭后水果互动", "室内/操作室/双人交互类桌游", "室内/养生健身室/五禽戏", "室内/摇滚工作室/手持麦克风", "室内/艺术室/使用平板", "室内/音乐厅/多人唱K", "室内/瑜伽室/功能性训练", "室内/运动器材室/喝饮料", "室内/杂货间/使用纸箱", "室内/杂货间/按摩", "室内/杂货间/飞盘抛接", "室内/展览馆/使用宣传物料", "室内/展厅/使用小桌子", "室内/展映海报旁/使用塑料袋", "室内/展映室/使用三脚架", "室内/直播室/摆放装饰画框", "室内/直播室/操作显示屏", "室内/直播室/使用KT板", "室内/直播室/使用头戴式麦克风", "室内/直播室/使用游戏鼠标", "室内/直播室/使用直播升降台", "室内/直播室/毽子操手部暖身", "室内/直播室/康复运动", "室内/直播室/宽距俯卧撑", "室内/直播室/跳绳", "室外/玻璃墙旁/矿泉水瓶套圈游戏", "室外/玻璃墙旁/练歌", "室外/玻璃墙旁/塑料圈套圈", "室外/草丛边空地/使用木棍拉伸", "室外/草丛边空地/全身燃脂健身操跟练", "室外/草坪/力量训练", "室外/草坪/日常模拟互动", "室外/草坪/丢沙包躲避游戏", "室外/草坪/接力传递塑料环", "室外/草坪/使用水瓶套圈", "室外/草坪/三人踢鸡毛毽子", "室外/草坪/飞盘抛接", "室外/草坪/使用平步机", "室外/草坪/塑料圈传递", "室外/道路区域/三人接力传递塑料环", "室外/道路区域/八段锦", "室外/道路区域/健身操视频跟练", "室外/道路区域/通经络操", "室外/道路区域/五禽戏", "室外/地下商城/站立热身", "室外/公共健身区/练习耍棍", "室外/公司楼下大坪/使用抹布", "室外/公园步道/三人跳皮筋", "室外/公园步道/童年游戏摔宝", "室外/公园草地/使用矿泉水瓶套圈", "室外/公园花坛/锻炼", "室外/公园花坛/争吵演绎", "室外/公园健身/拉伸操跟练", "室外/公园围墙边/资料整理", "室外/公园休息区/玩滑板车", "室外/广场/颠球", "室外/广场/使用防晒霜", "室外/广场/使用鼠标", "室外/广场/耍剑", "室外/广场/休闲活动情景演绎", "室外/广场/Urban舞蹈", "室外/广场/八段锦", "室外/广场/晨练运动", "室外/广场/健身操", "室外/广场/太极", "室外/广场/三人排球抛接", "室外/广场/玩球", "室外/广场/喂猫", "室外/广场/铺设野餐垫", "室外/广场/人宠互动", "室外/广场/使用编织篮", "室外/广场/团播互动", "室外/广场/吃早餐争吵", "室外/广场/健美操", "室外/广场/健身燃脂舞", "室外/广场/拍八虚", "室外/广场/双人热身运动", "室外/广场/双手摆动", "室外/红砖休息亭/轮流对墙练习篮球", "室外/户外活动区/课间运动", "室外/花坛/拍手游戏", "室外/活动区/多人网球接力抛接", "室外/健身房/练习太极拳", "室外/篮球场/打篮球", "室外/篮球场/打篮球", "室外/篮球场/三人使用网球训练器击打练习", "室外/篮球场/套圈套物", "室外/篮球场/双人围绕篮球操作", "室外/林荫道/使用羽毛球网", "室外/林荫小道/多人接力扔飞盘", "室外/马路旁/广播体操", "室外/毛坯商铺/使用体操彩带玩耍", "室外/乒乓球场/使用乒乓球台", "室外/人行道/休闲拉伸", "室外/社区凉亭旁/辩论", "室外/升旗台/多人看视频做拉伸互动", "室外/室内体育馆/力量训练", "室外/室外空地/塑料圈套圈", "室外/树林/飞盘接力", "室外/树林/篮球抛接练习", "室外/树荫通道/甩腿", "室外/树荫下空地/清扫落叶", "室外/树荫下空地/学习广播体操", "室外/树荫下空地/深蹲瘦腰", "室外/宿舍楼间通道/健身操", "室外/宿舍楼前停车区域/使用网球训练器练习有绳网球", "室外/塑胶运动场/擦洗电动车", "室外/田径场/休息放松", "室外/田径场/健身操", "室外/田径场/塑型操", "室外/停车场/观看视频学习拉伸互动", "室外/网球场/使用网球拍", "室外/小区晨练场所/使用八音琴", "室外/小区楼下/使用传单", "室外/小区楼下/思考问题", "室外/小区楼下/篮球进攻练习", "室外/小区楼下空地/热身运动", "室外/小区楼下空地/使用水桶投壶", "室外/小区楼下空地/拍手游戏", "室外/小区乒乓球台/简易太极拳", "室外/小区乒乓球台/使用乒乓球拍", "室外/小区羽毛球场/打羽毛球", "室外/小区羽毛球场/双人羽毛球对打", "室外/操作室/肩部放松", "室外/操作室/练气功", "室外/操作室后/使用冰敷贴", "室外/训练场/踢足球", "室外/训练场/啦啦操", "室外/训练场/使用毽子", "室外/夜市/互相补妆", "室外/夜市/与顾客讨论价格", "室外/羽毛球场/使用乒乓球", "室外/栅栏前空地/多人接力扔套圈", "室外/柱廊间空地/原地踏步", "室外/柱廊间空地/多人排球接力抛接", "室外/走廊/使用道具枪", "室外/走廊/视频学习舞蹈", "室外/走廊/疏肝操", "室外/走廊/三人使用网球训练器练习", "室外/走廊/内蒙古舞", "室外/走廊/使用道具剑", "室外/走廊/童年游戏摔宝", "室外/走廊/功能性训练", "室外/走廊/跳广场舞", "室外/足球场/冲拳", "室内/办公楼", "室内/办公室", "室内/玻璃门前空地", "室内/大厅", "室内/电竞室", "室内/雕塑室", "室内/多屏幕室内训练馆", "室内/工作室", "室内/公司活动室", "室内/功能室", "室内/广播录播室", "室内/化妆间", "室内/画室", "室内/会议室", "室内/机械仓库", "室内/健身房", "室内/酒店大厅", "室内/剧场", "室内/客厅", "室内/客厅沙发前", "室内/林荫道", "室内/录音棚", "室内/毛坯房内", "室内/美术室", "室内/喷泉前空地", "室内/器材仓库", "室内/烧烤摊摊车前", "室内/摄影棚", "室内/室内运动场所", "室内/书房", "室内/台球室", "室内/跳蚤市场", "室内/亭院", "室内/投影舞台", "室内/图书馆", "室内/卧室", "室内/舞蹈练习室", "室内/舞蹈室", "室内/新闻联播室", "室内/休息室", "室内/休闲活动区", "室内/操作室", "室内/养生健身室", "室内/摇滚工作室", "室内/艺术室", "室内/音乐厅", "室内/瑜伽室", "室内/运动器材室", "室内/杂货间", "室内/展览馆", "室内/展厅", "室内/展映海报旁", "室内/展映室", "室内/直播室", "室外/玻璃墙旁", "室外/草丛边空地", "室外/草坪", "室外/道路区域", "室外/地下商城", "室外/公共健身区", "室外/公司楼下大坪", "室外/公园步道", "室外/公园草地", "室外/公园花坛", "室外/公园健身", "室外/公园围墙边", "室外/公园休息区", "室外/广场", "室外/红砖休息亭", "室外/户外活动区", "室外/花坛", "室外/活动区", "室外/健身房", "室外/篮球场", "室外/林荫道", "室外/林荫小道", "室外/马路旁", "室外/毛坯商铺", "室外/乒乓球场", "室外/人行道", "室外/社区凉亭旁", "室外/升旗台", "室外/室内体育馆", "室外/室外空地", "室外/树林", "室外/树荫通道", "室外/树荫下空地", "室外/宿舍楼间通道", "室外/宿舍楼前停车区域", "室外/塑胶运动场", "室外/田径场", "室外/停车场", "室外/网球场", "室外/小区晨练场所", "室外/小区楼下", "室外/小区楼下空地", "室外/小区乒乓球台", "室外/小区羽毛球场", "室外/操作室", "室外/操作室后", "室外/训练场", "室外/夜市", "室外/羽毛球场", "室外/栅栏前空地", "室外/柱廊间空地", "室外/走廊", "室外/足球场", "室内", "室外"],
        labels: ["翻阅书本", "使用办公道具操作", "动态拉伸操", "双人摆pose", "复习功课", "日常运动", "使用乒乓球", "发放宣传单", "健身操视频跟练", "武术", "使用浇花器", "多人网球训练", "跳舞", "打闹互动", "使用办公场景道具", "摆放雕像", "脖颈运动", "吃零食", "使用胶带", "日常运动", "使用黑板刷", "家庭唱K", "清理垃圾", "使用扇子", "使用鸡毛掸子", "客厅阅读", "身体不舒服", "使用杠铃", "使用钢琴", "单人拉丁舞", "绘画教学", "关节运动", "佩戴遮阳帽", "聚会烧烤", "使用采访脚本", "使用手提包", "登山跑", "清理维护书房", "操作台球台", "翻看商品手册", "使用爱心箱", "打理花草", "打扫庭院", "舞台剧剧目表演", "使用软尺", "跟视频学习舞蹈", "使用马克笔", "房间内跳操", "枕头大战", "京剧表演", "采访脚本", "搬运行李箱", "视频学习街舞舞蹈", "使用筹码盒", "使用岛台", "双人台球对打", "查看彩票", "大扫除", "订书机、文件盒", "读书、听音乐、写日记", "粉笔擦+粉笔", "记录记账本", "剪纸", "模拟羽毛球训练", "泡泡面", "佩戴棒球帽", "拼搭积木", "上课", "摄影补光灯", "使用杯子", "使用餐巾纸", "使用充电器", "使用耳机", "使用高尔夫球杆", "使用购物袋", "使用化妆刷", "使用键盘", "使用卡片", "使用毛线团", "使用签名笔", "使用扫把", "使用小风扇", "使用颜料盘", "使用指甲刀", "踢毽子", "挑选面包", "玩玩偶挂件", "洗抹布", "演讲稿", "整理物品", "整理玩偶挂件", "整理文件", "整理文具袋", "装文件袋", "开门广播体操", "跳舞、锻炼", "八段锦", "八段锦、拉伸", "闭眼许愿", "表演话剧", "发呆", "复古舞蹈", "画前准备", "基础队列动作", "健身操", "健身等", "脚部运动", "啦啦操", "男团舞", "热身准备", "手部运动、腿部运动、肩部运动", "手写祝福", "体操训练", "跳跃", "舞蹈基本功训练", "学手语、拍抖音", "眼保健操", "远望", "早操", "宅舞", "真人CS情景演绎", "整理仪容仪表", "转头拉伸", "使用大提琴", "多人舞蹈", "歌朗诵", "广场舞", "街舞舞蹈学习", "课间嬉戏打闹", "少儿舞蹈教学", "手势舞", "团体舞", "玩游戏", "知识问答", "电脑协作体验", "快递取放", "使用泡泡机", "双人交谈场景", "帮背书", "表演才艺", "放松身体", "古法健身", "肩颈保健操", "拉伸、坐姿运动", "模仿游戏", "平衡协调互动", "双人打闹", "双人舞教学、双人减脂舞", "跳舞，拉伸", "同台竞演", "玩舞蹈游戏", "演唱会舞台唱歌表演", "主持人讲话", "做普拉提", "双人交互类收碗与饭后水果互动", "双人交互类桌游", "五禽戏", "手持麦克风", "使用平板", "多人唱K", "功能性训练", "喝饮料", "使用纸箱", "按摩", "飞盘抛接", "使用宣传物料", "使用小桌子", "使用塑料袋", "使用三脚架", "摆放装饰画框", "操作显示屏", "使用KT板", "使用头戴式麦克风", "使用游戏鼠标", "使用直播升降台", "毽子操手部暖身", "康复运动", "宽距俯卧撑", "跳绳", "矿泉水瓶套圈游戏", "练歌", "塑料圈套圈", "使用木棍拉伸", "全身燃脂健身操跟练", "力量训练", "日常模拟互动", "丢沙包躲避游戏", "接力传递塑料环", "使用水瓶套圈", "三人踢鸡毛毽子", "飞盘抛接", "使用平步机", "塑料圈传递", "三人接力传递塑料环", "八段锦", "健身操视频跟练", "通经络操", "五禽戏", "站立热身", "练习耍棍", "使用抹布", "三人跳皮筋", "童年游戏摔宝", "使用矿泉水瓶套圈", "锻炼", "争吵演绎", "拉伸操跟练", "资料整理", "玩滑板车", "颠球", "使用防晒霜", "使用鼠标", "耍剑", "休闲活动情景演绎", "Urban舞蹈", "八段锦", "晨练运动", "健身操", "太极", "三人排球抛接", "玩球", "喂猫", "铺设野餐垫", "人宠互动", "使用编织篮", "团播互动", "吃早餐争吵", "健美操", "健身燃脂舞", "拍八虚", "双人热身运动", "双手摆动", "轮流对墙练习篮球", "课间运动", "拍手游戏", "多人网球接力抛接", "练习太极拳", "打篮球", "打篮球", "三人使用网球训练器击打练习", "套圈套物", "双人围绕篮球操作", "使用羽毛球网", "多人接力扔飞盘", "广播体操", "使用体操彩带玩耍", "使用乒乓球台", "休闲拉伸", "辩论", "多人看视频做拉伸互动", "力量训练", "塑料圈套圈", "飞盘接力", "篮球抛接练习", "甩腿", "清扫落叶", "学习广播体操", "深蹲瘦腰", "健身操", "使用网球训练器练习有绳网球", "擦洗电动车", "休息放松", "健身操", "塑型操", "观看视频学习拉伸互动", "使用网球拍", "使用八音琴", "使用传单", "思考问题", "篮球进攻练习", "热身运动", "使用水桶投壶", "拍手游戏", "简易太极拳", "使用乒乓球拍", "打羽毛球", "双人羽毛球对打", "肩部放松", "练气功", "使用冰敷贴", "踢足球", "啦啦操", "使用毽子", "互相补妆", "与顾客讨论价格", "使用乒乓球", "多人接力扔套圈", "原地踏步", "多人排球接力抛接", "使用道具枪", "视频学习舞蹈", "疏肝操", "三人使用网球训练器练习", "内蒙古舞", "使用道具剑", "童年游戏摔宝", "功能性训练", "跳广场舞", "冲拳", "办公楼", "办公室", "玻璃门前空地", "大厅", "电竞室", "雕塑室", "多屏幕室内训练馆", "工作室", "公司活动室", "功能室", "广播录播室", "化妆间", "画室", "会议室", "机械仓库", "健身房", "酒店大厅", "剧场", "客厅", "客厅沙发前", "林荫道", "录音棚", "毛坯房内", "美术室", "喷泉前空地", "器材仓库", "烧烤摊摊车前", "摄影棚", "室内运动场所", "书房", "台球室", "跳蚤市场", "亭院", "投影舞台", "图书馆", "卧室", "舞蹈练习室", "舞蹈室", "新闻联播室", "休息室", "休闲活动区", "操作室", "养生健身室", "摇滚工作室", "艺术室", "音乐厅", "瑜伽室", "运动器材室", "杂货间", "展览馆", "展厅", "展映海报旁", "展映室", "直播室", "玻璃墙旁", "草丛边空地", "草坪", "道路区域", "地下商城", "公共健身区", "公司楼下大坪", "公园步道", "公园草地", "公园花坛", "公园健身", "公园围墙边", "公园休息区", "广场", "红砖休息亭", "户外活动区", "花坛", "活动区", "健身房", "篮球场", "林荫道", "林荫小道", "马路旁", "毛坯商铺", "乒乓球场", "人行道", "社区凉亭旁", "升旗台", "室内体育馆", "室外空地", "树林", "树荫通道", "树荫下空地", "宿舍楼间通道", "宿舍楼前停车区域", "塑胶运动场", "田径场", "停车场", "网球场", "小区晨练场所", "小区楼下", "小区楼下空地", "小区乒乓球台", "小区羽毛球场", "操作室", "操作室后", "训练场", "夜市", "羽毛球场", "栅栏前空地", "柱廊间空地", "走廊", "足球场", "室内", "室外"],
        marker: {"colors": ["#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#B76CAC", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#FECB52", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52", "#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#F7F7F7", "#D2232A"]},
        parents: ["室内/办公楼", "室内/办公楼", "室内/办公楼", "室内/办公楼", "室内/办公室", "室内/玻璃门前空地", "室内/大厅", "室内/电竞室", "室内/雕塑室", "室内/多屏幕室内训练馆", "室内/工作室", "室内/公司活动室", "室内/功能室", "室内/广播录播室", "室内/化妆间", "室内/画室", "室内/会议室", "室内/机械仓库", "室内/健身房", "室内/酒店大厅", "室内/剧场", "室内/客厅", "室内/客厅", "室内/客厅", "室内/客厅沙发前", "室内/客厅沙发前", "室内/林荫道", "室内/录音棚", "室内/录音棚", "室内/毛坯房内", "室内/美术室", "室内/喷泉前空地", "室内/器材仓库", "室内/烧烤摊摊车前", "室内/摄影棚", "室内/摄影棚", "室内/室内运动场所", "室内/书房", "室内/台球室", "室内/跳蚤市场", "室内/跳蚤市场", "室内/亭院", "室内/亭院", "室内/投影舞台", "室内/图书馆", "室内/图书馆", "室内/卧室", "室内/卧室", "室内/卧室", "室内/舞蹈练习室", "室内/舞蹈室", "室内/舞蹈室", "室内/舞蹈室", "室内/新闻联播室", "室内/休息室", "室内/休闲活动区", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/操作室", "室内/养生健身室", "室内/摇滚工作室", "室内/艺术室", "室内/音乐厅", "室内/瑜伽室", "室内/运动器材室", "室内/杂货间", "室内/杂货间", "室内/杂货间", "室内/展览馆", "室内/展厅", "室内/展映海报旁", "室内/展映室", "室内/直播室", "室内/直播室", "室内/直播室", "室内/直播室", "室内/直播室", "室内/直播室", "室内/直播室", "室内/直播室", "室内/直播室", "室内/直播室", "室外/玻璃墙旁", "室外/玻璃墙旁", "室外/玻璃墙旁", "室外/草丛边空地", "室外/草丛边空地", "室外/草坪", "室外/草坪", "室外/草坪", "室外/草坪", "室外/草坪", "室外/草坪", "室外/草坪", "室外/草坪", "室外/草坪", "室外/道路区域", "室外/道路区域", "室外/道路区域", "室外/道路区域", "室外/道路区域", "室外/地下商城", "室外/公共健身区", "室外/公司楼下大坪", "室外/公园步道", "室外/公园步道", "室外/公园草地", "室外/公园花坛", "室外/公园花坛", "室外/公园健身", "室外/公园围墙边", "室外/公园休息区", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/广场", "室外/红砖休息亭", "室外/户外活动区", "室外/花坛", "室外/活动区", "室外/健身房", "室外/篮球场", "室外/篮球场", "室外/篮球场", "室外/篮球场", "室外/篮球场", "室外/林荫道", "室外/林荫小道", "室外/马路旁", "室外/毛坯商铺", "室外/乒乓球场", "室外/人行道", "室外/社区凉亭旁", "室外/升旗台", "室外/室内体育馆", "室外/室外空地", "室外/树林", "室外/树林", "室外/树荫通道", "室外/树荫下空地", "室外/树荫下空地", "室外/树荫下空地", "室外/宿舍楼间通道", "室外/宿舍楼前停车区域", "室外/塑胶运动场", "室外/田径场", "室外/田径场", "室外/田径场", "室外/停车场", "室外/网球场", "室外/小区晨练场所", "室外/小区楼下", "室外/小区楼下", "室外/小区楼下", "室外/小区楼下空地", "室外/小区楼下空地", "室外/小区楼下空地", "室外/小区乒乓球台", "室外/小区乒乓球台", "室外/小区羽毛球场", "室外/小区羽毛球场", "室外/操作室", "室外/操作室", "室外/操作室后", "室外/训练场", "室外/训练场", "室外/训练场", "室外/夜市", "室外/夜市", "室外/羽毛球场", "室外/栅栏前空地", "室外/柱廊间空地", "室外/柱廊间空地", "室外/走廊", "室外/走廊", "室外/走廊", "室外/走廊", "室外/走廊", "室外/走廊", "室外/走廊", "室外/走廊", "室外/走廊", "室外/足球场", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室内", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "室外", "", ""],
        values: [5, 13, 9, 13, 5, 46, 2, 6, 12, 5, 11, 23, 4, 9, 15, 8, 8, 9, 9, 13, 4, 5, 8, 7, 11, 11, 10, 10, 9, 7, 12, 34, 5, 7, 13, 8, 9, 7, 9, 9, 1, 1, 8, 5, 3, 7, 8, 6, 8, 30, 13, 11, 39, 19, 9, 5, 7, 10, 17, 15, 16, 8, 38, 9, 49, 11, 6, 22, 14, 13, 9, 10, 2, 11, 10, 9, 2, 7, 4, 6, 12, 8, 6, 7, 15, 9, 46, 14, 14, 778, 5, 9, 8, 22, 17, 12, 10, 14, 9, 4, 10, 2, 5, 8, 8, 16, 16, 13, 7, 8, 18, 7, 13, 6, 10, 15, 12, 9, 6, 8, 11, 31, 11, 8, 9, 8, 17, 11, 24, 10, 9, 13, 6, 9, 9, 9, 10, 19, 7, 12, 10, 6, 9, 29, 34, 1, 14, 16, 14, 7, 18, 11, 7, 14, 10, 15, 11, 6, 1, 17, 8, 7, 9, 30, 20, 6, 12, 4, 2, 4, 12, 7, 26, 14, 6, 9, 8, 9, 2, 6, 8, 6, 6, 1, 15, 9, 15, 8, 24, 30, 1, 16, 9, 6, 7, 18, 8, 1, 16, 17, 4, 2, 41, 19, 14, 16, 7, 8, 9, 8, 15, 12, 11, 12, 8, 11, 9, 12, 14, 12, 10, 15, 13, 9, 6, 8, 13, 8, 8, 9, 23, 10, 6, 11, 12, 15, 43, 12, 9, 11, 10, 46, 17, 8, 26, 2, 5, 14, 8, 2, 26, 7, 7, 4, 2, 30, 18, 8, 5, 10, 38, 7, 1, 7, 30, 17, 10, 3, 6, 3, 39, 10, 12, 11, 45, 31, 11, 5, 6, 9, 7, 23, 19, 6, 7, 6, 14, 13, 13, 16, 21, 8, 14, 12, 16, 17, 12, 17, 3, 40, 5, 46, 2, 6, 12, 5, 11, 23, 4, 9, 15, 8, 8, 9, 9, 13, 4, 20, 22, 10, 19, 7, 12, 34, 5, 7, 21, 9, 7, 9, 10, 9, 5, 11, 22, 30, 63, 19, 9, 5, 1980, 11, 6, 1, 17, 8, 7, 59, 6, 12, 4, 2, 99, 20, 7, 127, 41, 16, 17, 4, 44, 19, 30, 7, 8, 9, 257, 6, 11, 12, 15, 43, 89, 17, 8, 26, 2, 5, 14, 8, 2, 26, 7, 12, 2, 56, 5, 10, 38, 15, 30, 17, 10, 12, 61, 57, 42, 11, 9, 49, 13, 6, 14, 26, 133, 3, 2806, 1528]
        // branchvalues: "total",
        // customdata: [["Library"], ["Corridor"], ["Cafe"], ["Courtyard"], ["Square"], ["Square"], ["Cafe"], ["Square"], ["Platform"], ["Library"], ["Square"], ["Courtyard"], ["Cafe"], ["Library"], ["Square"], ["Library"], ["Sport Court"], ["Library"], ["Square"], ["Square"], ["Courtyard"], ["Square"], ["Corridor"], ["Square"], ["Platform"], ["Courtyard"], ["Courtyard"], ["Square"], ["Courtyard"], ["Platform"], ["Courtyard"], ["Square"], ["Sport Court"], ["Corridor"], ["Courtyard"], ["Square"], ["Library"], ["Square"], ["Cafe"], ["Corridor"], ["Library"], ["Library"], ["Square"], ["Library"], ["Platform"], ["Corridor"], ["Sport Court"], ["Platform"], ["Park"], ["Dance Room"], ["Platform"], ["Square"], ["Sport Court"], ["Library"], ["Corridor"], ["Platform"], ["Cafe"], ["Square"], ["Sport Court"], ["Corridor"], ["Platform"], ["Platform"], ["Square"], ["Square"], ["Library"], ["Library"], ["Square"], ["Sport Court"], ["Library"], ["Corridor"], ["Square"], ["Sport Court"], ["Library"], ["Corridor"], ["Cafe"], ["Corridor"], ["Square"], ["Square"], ["Courtyard"], ["Courtyard"], ["Dance Room"], ["Park"], ["Platform"], ["Square"], ["Platform"], ["Dance Room"], ["Square"], ["Corridor"], ["Sport Court"], ["Square"], ["Dance Room"], ["Square"], ["Library"], ["Square"], ["Sport Court"], ["Library"], ["Courtyard"], ["Corridor"], ["Sport Court"], ["Square"], ["Library"], ["Square"], ["Square"], ["Square"], ["Platform"], ["Courtyard"], ["Square"], ["Square"], ["Square"], ["Sport Court"], ["Sport Court"], ["Sport Court"], ["Square"], ["Corridor"], ["Cafe"], ["Platform"], ["Sport Court"], ["Courtyard"], ["Square"], ["Library"], ["Square"], ["Sport Court"], ["Corridor"], ["Lobby"], ["Library"], ["Square"], ["Cafe"], ["Cafe"], ["Corridor"], ["Courtyard"], ["Library"], ["Square"], ["Sport Court"], ["Square"], ["Library"], ["Square"], ["Courtyard"], ["Library"], ["Lobby"], ["Courtyard"], ["Square"], ["Library"], ["Corridor"], ["Square"], ["Platform"], ["Dance Room"], ["Square"], ["Dance Room"], ["Courtyard"], ["Corridor"], ["Square"], ["Library"], ["Cafe"], ["Square"], ["Lobby"], ["Courtyard"], ["Square"], ["Corridor"], ["Courtyard"], ["Dance Room"], ["Library"], ["Lobby"], ["Park"], ["Platform"], ["Sport Court"], ["Square"], ["(?)"], ["(?)"]],
        // ids: ["Indoor/Library/Greeting", "Indoor/Corridor/Greeting", "Outdoor/Cafe/Greeting", "Outdoor/Courtyard/Folk dance", "Outdoor/Square/Flybird", "Outdoor/Square/Eat", "Outdoor/Cafe/Eat", "Outdoor/Square/Drink", "Outdoor/Platform/Eat", "Indoor/Library/Walk", "Outdoor/Square/Umbrella", "Outdoor/Courtyard/Umbrella", "Outdoor/Cafe/Umbrella", "Indoor/Library/Wash hands", "Outdoor/Square/Wear headphone", "Indoor/Library/Wear glasses", "Outdoor/Sport Court/Wave hands", "Indoor/Library/Write", "Outdoor/Square/Wash hands", "Outdoor/Square/Upstair", "Outdoor/Courtyard/Urban", "Outdoor/Square/Urban", "Indoor/Corridor/Walk", "Outdoor/Square/Wacking", "Outdoor/Platform/Wave hands", "Outdoor/Courtyard/Wacking", "Outdoor/Courtyard/Move chair", "Outdoor/Square/Kick shuttlecock", "Outdoor/Courtyard/Kpop", "Outdoor/Platform/Latin", "Outdoor/Courtyard/Latin", "Outdoor/Square/Latin", "Outdoor/Sport Court/Leg lifting", "Indoor/Corridor/Move chair", "Outdoor/Courtyard/Make hair", "Outdoor/Square/Lateral raise", "Indoor/Library/Move chair", "Outdoor/Square/Leg lifting", "Outdoor/Cafe/Move mat", "Indoor/Corridor/Move mat", "Indoor/Library/Move mat", "Indoor/Library/Make hair", "Outdoor/Square/Move chair", "Indoor/Library/Make table", "Outdoor/Platform/Strentch lower", "Indoor/Corridor/Strentch lower", "Outdoor/Sport Court/Strentch", "Outdoor/Platform/Strentch", "Outdoor/Park/Strentch", "Indoor/Dance Room/Strentch", "Outdoor/Platform/Talk", "Outdoor/Square/Tie shoe", "Outdoor/Sport Court/Tie shoe", "Indoor/Library/Tie shoe", "Indoor/Corridor/Tie shoe", "Outdoor/Platform/Throw", "Outdoor/Cafe/Throw", "Outdoor/Square/Talk", "Outdoor/Sport Court/Talk", "Indoor/Corridor/Turn around", "Outdoor/Platform/Turn around", "Outdoor/Platform/Taichi", "Outdoor/Square/Typing", "Outdoor/Square/Take bag", "Indoor/Library/Take bag", "Indoor/Library/Talk", "Outdoor/Square/Strentch upper", "Outdoor/Sport Court/Strentch upper", "Indoor/Library/Strentch upper", "Indoor/Corridor/Strentch upper", "Outdoor/Square/Strentch lower", "Outdoor/Sport Court/Strentch lower", "Indoor/Library/Typing", "Indoor/Corridor/Talk", "Outdoor/Cafe", "Indoor/Corridor", "Outdoor/Square/Write", "Outdoor/Square/Stand", "Outdoor/Courtyard/Strentch", "Outdoor/Courtyard/Hiphop", "Indoor/Dance Room/Hiphop", "Outdoor/Park/Hiphop", "Outdoor/Platform/Hiphop", "Outdoor/Square/Hiphop", "Outdoor/Platform/Kick", "Indoor/Dance Room/Jazz", "Outdoor/Square/Jazz", "Indoor/Corridor/Jump", "Outdoor/Sport Court/Jump", "Outdoor/Square/Jump", "Indoor/Dance Room/K-Pop", "Outdoor/Square/Jacket", "Indoor/Library/Jacket", "Outdoor/Square/Aerobics", "Outdoor/Sport Court/Drink", "Indoor/Library/Drink", "Outdoor/Courtyard/Drink", "Indoor/Corridor/Drink", "Outdoor/Sport Court/Dribble", "Outdoor/Square/Cross barrier", "Indoor/Library/Clean table", "Outdoor/Square/Dance", "Outdoor/Square/Clean", "Outdoor/Square/Breaking", "Outdoor/Platform/Boxing", "Outdoor/Courtyard/Ballet", "Outdoor/Square/Arm lifting", "Outdoor/Square/Arm curl", "Outdoor/Square/Clean chair", "Outdoor/Sport Court/Move things", "Outdoor/Sport Court/Pass ball", "Outdoor/Sport Court/Pass", "Outdoor/Square/Packaging", "Indoor/Corridor/Packaging", "Outdoor/Cafe/Packaging", "Outdoor/Platform/Move things", "Outdoor/Sport Court/Shoot ball", "Outdoor/Courtyard/Move things", "Outdoor/Square/Move table", "Indoor/Library/Move table", "Outdoor/Square/Move mat", "Outdoor/Sport Court/Move mat", "Indoor/Corridor/Phone call", "Indoor/Lobby/Move things", "Indoor/Library/Phone call", "Outdoor/Square/Phone call", "Outdoor/Cafe/Photo", "Outdoor/Cafe/Sit", "Indoor/Corridor/Sit", "Outdoor/Courtyard/Sit", "Indoor/Library/Sit", "Outdoor/Square/Sit", "Outdoor/Sport Court/Skipping rope", "Outdoor/Square/Skipping rope", "Indoor/Library/Sleep", "Outdoor/Square/Squat", "Outdoor/Courtyard/Stand", "Indoor/Library/Stand", "Indoor/Lobby/Relax", "Outdoor/Courtyard/Relax", "Outdoor/Square/Read", "Indoor/Library/Read", "Indoor/Corridor/Push up", "Outdoor/Square/Posing", "Outdoor/Platform/Posing", "Indoor/Dance Room/Popping", "Outdoor/Square/Play phone", "Indoor/Dance Room/Play phone", "Outdoor/Courtyard/Play phone", "Indoor/Corridor/Play phone", "Outdoor/Square/Pick things", "Indoor/Library/Pick things", "Outdoor/Cafe/Pick thing", "Outdoor/Square/Photo", "Indoor/Lobby/Photo", "Outdoor/Courtyard/Photo", "Outdoor/Square/Rowing", "Indoor/Corridor/Pick things", "Outdoor/Courtyard", "Indoor/Dance Room", "Indoor/Library", "Indoor/Lobby", "Outdoor/Park", "Outdoor/Platform", "Outdoor/Sport Court", "Outdoor/Square", "Indoor", "Outdoor"],
        // labels: ["Greeting", "Greeting", "Greeting", "Folk dance", "Flybird", "Eat", "Eat", "Drink", "Eat", "Walk", "Umbrella", "Umbrella", "Umbrella", "Wash hands", "Wear headphone", "Wear glasses", "Wave hands", "Write", "Wash hands", "Upstair", "Urban", "Urban", "Walk", "Wacking", "Wave hands", "Wacking", "Move chair", "Kick shuttlecock", "Kpop", "Latin", "Latin", "Latin", "Leg lifting", "Move chair", "Make hair", "Lateral raise", "Move chair", "Leg lifting", "Move mat", "Move mat", "Move mat", "Make hair", "Move chair", "Make table", "Strentch lower", "Strentch lower", "Strentch", "Strentch", "Strentch", "Strentch", "Talk", "Tie shoe", "Tie shoe", "Tie shoe", "Tie shoe", "Throw", "Throw", "Talk", "Talk", "Turn around", "Turn around", "Taichi", "Typing", "Take bag", "Take bag", "Talk", "Strentch upper", "Strentch upper", "Strentch upper", "Strentch upper", "Strentch lower", "Strentch lower", "Typing", "Talk", "Cafe", "Corridor", "Write", "Stand", "Strentch", "Hiphop", "Hiphop", "Hiphop", "Hiphop", "Hiphop", "Kick", "Jazz", "Jazz", "Jump", "Jump", "Jump", "K-Pop", "Jacket", "Jacket", "Aerobics", "Drink", "Drink", "Drink", "Drink", "Dribble", "Cross barrier", "Clean table", "Dance", "Clean", "Breaking", "Boxing", "Ballet", "Arm lifting", "Arm curl", "Clean chair", "Move things", "Pass ball", "Pass", "Packaging", "Packaging", "Packaging", "Move things", "Shoot ball", "Move things", "Move table", "Move table", "Move mat", "Move mat", "Phone call", "Move things", "Phone call", "Phone call", "Photo", "Sit", "Sit", "Sit", "Sit", "Sit", "Skipping rope", "Skipping rope", "Sleep", "Squat", "Stand", "Stand", "Relax", "Relax", "Read", "Read", "Push up", "Posing", "Posing", "Popping", "Play phone", "Play phone", "Play phone", "Play phone", "Pick things", "Pick things", "Pick thing", "Photo", "Photo", "Photo", "Rowing", "Pick things", "Courtyard", "Dance Room", "Library", "Lobby", "Park", "Platform", "Sport Court", "Square", "Indoor", "Outdoor"],
        // marker: {
        //   colors: ["#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#FFA15A", "#00cc96", "#FFA15A", "#19d3f3", "#636efa", "#FFA15A", "#ab63fa", "#00cc96", "#636efa", "#FFA15A", "#636efa", "#FF6692", "#636efa", "#FFA15A", "#FFA15A", "#ab63fa", "#FFA15A", "#EF553B", "#FFA15A", "#19d3f3", "#ab63fa", "#ab63fa", "#FFA15A", "#ab63fa", "#19d3f3", "#ab63fa", "#FFA15A", "#FF6692", "#EF553B", "#ab63fa", "#FFA15A", "#636efa", "#FFA15A", "#00cc96", "#EF553B", "#636efa", "#636efa", "#FFA15A", "#636efa", "#19d3f3", "#EF553B", "#FF6692", "#19d3f3", "#B6E880", "#FF97FF", "#19d3f3", "#FFA15A", "#FF6692", "#636efa", "#EF553B", "#19d3f3", "#00cc96", "#FFA15A", "#FF6692", "#EF553B", "#19d3f3", "#19d3f3", "#FFA15A", "#FFA15A", "#636efa", "#636efa", "#FFA15A", "#FF6692", "#636efa", "#EF553B", "#FFA15A", "#FF6692", "#636efa", "#EF553B", "#00cc96", "#EF553B", "#FFA15A", "#FFA15A", "#ab63fa", "#ab63fa", "#FF97FF", "#B6E880", "#19d3f3", "#FFA15A", "#19d3f3", "#FF97FF", "#FFA15A", "#EF553B", "#FF6692", "#FFA15A", "#FF97FF", "#FFA15A", "#636efa", "#FFA15A", "#FF6692", "#636efa", "#ab63fa", "#EF553B", "#FF6692", "#FFA15A", "#636efa", "#FFA15A", "#FFA15A", "#FFA15A", "#19d3f3", "#ab63fa", "#FFA15A", "#FFA15A", "#FFA15A", "#FF6692", "#FF6692", "#FF6692", "#FFA15A", "#EF553B", "#00cc96", "#19d3f3", "#FF6692", "#ab63fa", "#FFA15A", "#636efa", "#FFA15A", "#FF6692", "#EF553B", "#FECB52", "#636efa", "#FFA15A", "#00cc96", "#00cc96", "#EF553B", "#ab63fa", "#636efa", "#FFA15A", "#FF6692", "#FFA15A", "#636efa", "#FFA15A", "#ab63fa", "#636efa", "#FECB52", "#ab63fa", "#FFA15A", "#636efa", "#EF553B", "#FFA15A", "#19d3f3", "#FF97FF", "#FFA15A", "#FF97FF", "#ab63fa", "#EF553B", "#FFA15A", "#636efa", "#00cc96", "#FFA15A", "#FECB52", "#ab63fa", "#FFA15A", "#EF553B", "#ab63fa", "#FF97FF", "#636efa", "#FECB52", "#B6E880", "#19d3f3", "#FF6692", "#FFA15A", "#636efa", "#636efa"]
        // },
        // parents: ["Indoor/Library", "Indoor/Corridor", "Outdoor/Cafe", "Outdoor/Courtyard", "Outdoor/Square", "Outdoor/Square", "Outdoor/Cafe", "Outdoor/Square", "Outdoor/Platform", "Indoor/Library", "Outdoor/Square", "Outdoor/Courtyard", "Outdoor/Cafe", "Indoor/Library", "Outdoor/Square", "Indoor/Library", "Outdoor/Sport Court", "Indoor/Library", "Outdoor/Square", "Outdoor/Square", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Corridor", "Outdoor/Square", "Outdoor/Platform", "Outdoor/Courtyard", "Outdoor/Courtyard", "Outdoor/Square", "Outdoor/Courtyard", "Outdoor/Platform", "Outdoor/Courtyard", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Corridor", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Cafe", "Indoor/Corridor", "Indoor/Library", "Indoor/Library", "Outdoor/Square", "Indoor/Library", "Outdoor/Platform", "Indoor/Corridor", "Outdoor/Sport Court", "Outdoor/Platform", "Outdoor/Park", "Indoor/Dance Room", "Outdoor/Platform", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Library", "Indoor/Corridor", "Outdoor/Platform", "Outdoor/Cafe", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Corridor", "Outdoor/Platform", "Outdoor/Platform", "Outdoor/Square", "Outdoor/Square", "Indoor/Library", "Indoor/Library", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Library", "Indoor/Corridor", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Library", "Indoor/Corridor", "Outdoor", "Indoor", "Outdoor/Square", "Outdoor/Square", "Outdoor/Courtyard", "Outdoor/Courtyard", "Indoor/Dance Room", "Outdoor/Park", "Outdoor/Platform", "Outdoor/Square", "Outdoor/Platform", "Indoor/Dance Room", "Outdoor/Square", "Indoor/Corridor", "Outdoor/Sport Court", "Outdoor/Square", "Indoor/Dance Room", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Library", "Outdoor/Courtyard", "Indoor/Corridor", "Outdoor/Sport Court", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Square", "Outdoor/Square", "Outdoor/Platform", "Outdoor/Courtyard", "Outdoor/Square", "Outdoor/Square", "Outdoor/Square", "Outdoor/Sport Court", "Outdoor/Sport Court", "Outdoor/Sport Court", "Outdoor/Square", "Indoor/Corridor", "Outdoor/Cafe", "Outdoor/Platform", "Outdoor/Sport Court", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Corridor", "Indoor/Lobby", "Indoor/Library", "Outdoor/Square", "Outdoor/Cafe", "Outdoor/Cafe", "Indoor/Corridor", "Outdoor/Courtyard", "Indoor/Library", "Outdoor/Square", "Outdoor/Sport Court", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Courtyard", "Indoor/Library", "Indoor/Lobby", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Library", "Indoor/Corridor", "Outdoor/Square", "Outdoor/Platform", "Indoor/Dance Room", "Outdoor/Square", "Indoor/Dance Room", "Outdoor/Courtyard", "Indoor/Corridor", "Outdoor/Square", "Indoor/Library", "Outdoor/Cafe", "Outdoor/Square", "Indoor/Lobby", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Corridor", "Outdoor", "Indoor", "Indoor", "Indoor", "Outdoor", "Outdoor", "Outdoor", "Outdoor", "", ""],
        // values: [20248, 4432, 21784, 65792, 21984, 11328, 40048, 183824, 4064, 42608, 56032, 33192, 22144, 52616, 18624, 21184, 7416, 144328, 17568, 63792, 264272, 360808, 5472, 13650, 4280, 86016, 5400, 101312, 81128, 184760, 282560, 68508, 3264, 2480, 4832, 44832, 25104, 13584, 5200, 3200, 54264, 29440, 31744, 118792, 5008, 2608, 18512, 26472, 71024, 15648, 4272, 63424, 3232, 15936, 1656, 62616, 5000, 196750, 1056, 1824, 1408, 23400, 22800, 36240, 7072, 224968, 49336, 136936, 30144, 5080, 64768, 85088, 106048, 2832, 162472, 118056, 39904, 16896, 289192, 434816, 12008, 477936, 118144, 332263, 1056, 552757, 68325, 2016, 2000, 51504, 178488, 78888, 111680, 40920, 6400, 127472, 19392, 27744, 183872, 6768, 33176, 25824, 66912, 268016, 10448, 105736, 62928, 22176, 12240, 8616, 151512, 22336, 53640, 7472, 21608, 12000, 234120, 4056, 16112, 35592, 10992, 8400, 25208, 22824, 130928, 76272, 23656, 14424, 12688, 3864, 159384, 110952, 135648, 268832, 67256, 59664, 2624, 26936, 2600, 20848, 172184, 94256, 1424, 11112, 1200, 117944, 5088, 11112, 6248, 11120, 3408, 58320, 8608, 112344, 20400, 45304, 78072, 800, 1755272, 887957, 1737752, 45824, 548960, 459128, 1008408, 3513144, 2789589, 7447384]
      },
      comparisonData: [
        { name: '中广天择多视角数据集（2026）', environment: '真实场景', scenes: '2000+', duration: '10000+小时', one_min: '60分钟', cameras: '6', fps: '30', people: '6000+', isOurs: true, isFixed: false },
        { name: '数据集-A (2024)', environment: '真实场景', scenes: '10', duration: '13小时', one_min: '1分钟', cameras: '8', fps: '30 / 60', people: '40', isOurs: false, isFixed: false },
        { name: '数据集-B (2019)', environment: '真实场景', scenes: '1', duration: '1小时', one_min: '2分钟', cameras: '14', fps: '30', people: '8', isOurs: false, isFixed: true },
        { name: '数据集-C (2023)', environment: '实验室', scenes: '17', duration: '20小时', one_min: '6分钟', cameras: '4', fps: '50', people: '11', isOurs: false, isFixed: true },
        { name: '数据集-D (2018)', environment: '实验室', scenes: '1', duration: '5.5小时', one_min: '1分钟', cameras: '31', fps: '30', people: '8', isOurs: false, isFixed: true },
        { name: '数据集-E (2023)', environment: '真实场景', scenes: '3', duration: '2小时', one_min: '1分钟', cameras: '8', fps: '30', people: '36', isOurs: false, isFixed: true },
        { name: '数据集-F (2019)', environment: '真实场景', scenes: '4', duration: '1小时', one_min: '4分钟', cameras: '1', fps: '30', people: '7', isOurs: false, isFixed: true },
        { name: '数据集-G (2022)', environment: '实验室', scenes: '1', duration: '3小时', one_min: '1分钟', cameras: '11', fps: '30', people: '132', isOurs: false, isFixed: true }
        // { name: 'FreeMan (2024)', environment: '真实场景', scenes: '10', duration: '13小时', cameras: '8', fps: '30 / 60', people: '40', isOurs: false },
        // { name: 'MPI-INF-3DHP', environment: '真实场景', scenes: '1', duration: '2小时', cameras: '14', fps: '30', people: '8', isOurs: false },
        // { name: 'Human3.6M', environment: '实验室', scenes: '17', duration: '20小时', cameras: '4', fps: '50', people: '11', isOurs: false },
        // { name: 'CMU Panoptic Studio', environment: '实验室', scenes: '1', duration: '5.5小时', cameras: '31', fps: '30', people: '8', isOurs: false },
        // { name: 'Human-M3 (2023)', environment: '真实场景', scenes: '3', duration: '2小时', cameras: '8', fps: '30', people: '36', isOurs: false },
        // { name: '3DPW', environment: '真实场景', scenes: '4', duration: '1小时', cameras: '1', fps: '30', people: '7', isOurs: false },
        // { name: 'HuMMan-Released', environment: '实验室', scenes: '1', duration: '4小时', cameras: '11', fps: '30', people: '132', isOurs: false }

      ],
      // 视频播放器状态
      isPlaying: false,
      showControls: false,
      isLooping: false,
      isMuted: false,
      currentTime: '0:00',
      duration: '0:00',
      progressPercentage: 0,
      // 视频滚动观察器和事件处理器
      videoObserver: null,
      videoScrollHandler: null,
      videoLoadedDataHandler: null
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    // 视频自动播放处理（浏览器兼容性）
    this.initVideo();
    // 动态加载 Plotly.js
    this.loadPlotlyScript();
    // 初始化视频滚动播放观察器
    this.initVideoScrollObserver();

    // 初始化悬浮栏事件
    this.initSidebarEvents();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    // 清理 Plotly 图表
    if (window.Plotly && this.plotlyLoaded) {
      const container = document.getElementById('plotly-action-viz');
      if (container) {
        window.Plotly.purge('plotly-action-viz');
      }
    }
    // 清理视频滚动观察器
    if (this.videoObserver) {
      this.videoObserver.disconnect();
      this.videoObserver = null;
    }
    // 清理视频滚动事件处理器
    if (this.videoScrollHandler) {
      window.removeEventListener('scroll', this.videoScrollHandler);
      this.videoScrollHandler = null;
    }
    // 清理视频元素事件监听器
    const video = this.$refs.introVideo;
    if (video) {
      video.removeEventListener('loadeddata', this.onVideoLoaded);
      video.removeEventListener('timeupdate', this.onTimeUpdate);
      video.removeEventListener('ended', this.onVideoEnded);
      // 清理滚动观察器添加的 loadeddata 事件
      if (this.videoLoadedDataHandler) {
        video.removeEventListener('loadeddata', this.videoLoadedDataHandler);
        this.videoLoadedDataHandler = null;
      }
    }
  },
  methods: {
    expandFeishuQR() {
      this.showFeishuPreview = true;
    },
    closeFeishuPreview() {
      this.showFeishuPreview = false;
    },
    initSidebarEvents() {
      // 添加点击状态变量
      this.feishuTooltipVisible = false;
      this.emailTooltipVisible = false;

      // 飞书按钮 - 展示图片
      const feishuBtn = document.getElementById('feishu-btn');
      if (feishuBtn) {
        const tooltip = document.createElement('div');
        tooltip.className = 'fixed-tooltip';
        tooltip.style.cssText = 'position: absolute; right: 82px; top: 50%; transform: translateY(-50%); background: #ffffff; border-radius: 12px; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15); z-index: 1000000; padding: 20px; display: none;';

        // 使用require获取图片路径
        const imgUrl = require('./assets/img/tongna.png');

        tooltip.innerHTML = `
          <div style="width: 200px; height: 200px; display: flex; align-items: center; justify-content: center; background: #f8fafc; border-radius: 8px; overflow: hidden;">
            <img src="${imgUrl}" alt="飞书二维码" style="width: 100%; height: 100%; object-fit: contain;">
          </div>
        `;
        feishuBtn.appendChild(tooltip);

        // 悬停显示（仅在未固定显示时）
        feishuBtn.addEventListener('mouseenter', () => {
          if (!this.feishuTooltipVisible && !this.emailTooltipVisible) {
            tooltip.style.display = 'block';
          }
        });
        feishuBtn.addEventListener('mouseleave', () => {
          if (!this.feishuTooltipVisible) {
            tooltip.style.display = 'none';
          }
        });

        // 点击固定显示/隐藏
        feishuBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();

          // 切换飞书显示状态
          this.feishuTooltipVisible = !this.feishuTooltipVisible;

          if (this.feishuTooltipVisible) {
            // 显示飞书，隐藏邮箱
            tooltip.style.display = 'block';
            this.emailTooltipVisible = false;
            const emailTooltip = document.querySelector('#email-btn .fixed-tooltip');
            if (emailTooltip) {
              emailTooltip.style.display = 'none';
            }
          } else {
            // 隐藏飞书
            tooltip.style.display = 'none';
          }
        });
      }

      // 邮箱按钮 - 展示邮箱地址文本
      const emailBtn = document.getElementById('email-btn');
      if (emailBtn) {
        const tooltip = document.createElement('div');
        tooltip.className = 'fixed-tooltip';
        tooltip.style.cssText = 'position: absolute; right: 82px; top: 50%; transform: translateY(-50%); background: #ffffff; border-radius: 12px; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15); z-index: 1000000; padding: 20px; display: none; cursor: pointer;';
        tooltip.innerHTML = `
          <div style="width: 200px; text-align: center;">
            <div style="font-size: 12px; color: #94a3b8; margin-bottom: 8px;">联系我们</div>
            <div style="font-size: 15px; color: #0f172a; font-weight: 600; word-break: break-all;">
              szzx@tvzone.cn
            </div>
          </div>
        `;
        emailBtn.appendChild(tooltip);

        // 悬停显示（仅在未固定显示时）
        emailBtn.addEventListener('mouseenter', () => {
          if (!this.emailTooltipVisible && !this.feishuTooltipVisible) {
            tooltip.style.display = 'block';
          }
        });
        emailBtn.addEventListener('mouseleave', () => {
          if (!this.emailTooltipVisible) {
            tooltip.style.display = 'none';
          }
        });

        // 点击固定显示/隐藏并复制
        emailBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();

          // 切换邮箱显示状态
          this.emailTooltipVisible = !this.emailTooltipVisible;

          if (this.emailTooltipVisible) {
            // 显示邮箱，隐藏飞书
            tooltip.style.display = 'block';
            this.feishuTooltipVisible = false;
            const feishuTooltip = document.querySelector('#feishu-btn .fixed-tooltip');
            if (feishuTooltip) {
              feishuTooltip.style.display = 'none';
            }
            // 复制邮箱地址
            this.copyEmailToClipboard();
          } else {
            // 隐藏邮箱
            tooltip.style.display = 'none';
          }
        });
      }

      // 点击页面其他地方关闭所有tooltip
      document.addEventListener('click', () => {
        this.feishuTooltipVisible = false;
        this.emailTooltipVisible = false;
        const allTooltips = document.querySelectorAll('.fixed-tooltip');
        allTooltips.forEach(t => t.style.display = 'none');
      });
    },

    copyEmailToClipboard() {
      const email = 'szzx@tvzone.cn';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).then(() => {
          console.log('邮箱地址已复制到剪贴板');
          this.showCopySuccess('邮箱地址已复制');
        }).catch(err => {
          console.error('复制失败:', err);
          this.showCopySuccess('复制失败，请手动复制', true);
        });
      } else {
        // 兼容旧版浏览器的复制方法
        const textArea = document.createElement('textarea');
        textArea.value = email;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          console.log('邮箱地址已复制到剪贴板');
          this.showCopySuccess('邮箱地址已复制');
        } catch (err) {
          console.error('复制失败:', err);
          this.showCopySuccess('复制失败，请手动复制', true);
        }
        document.body.removeChild(textArea);
      }
    },

    handleFeishuEnter() {

      console.log('飞书鼠标进入');
      this.showFeishuTip = true;
      this.$forceUpdate();
    },
    handleScroll() {
      const scrollY = window.scrollY;

      // 导航栏固定逻辑 - 滚动超过0px就固定
      if (scrollY > 0) {
        this.isNavbarFixed = true;
      } else {
        this.isNavbarFixed = false;
      }

      // 滚动超过100px时添加阴影效果
      if (scrollY > 100) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }

      // 根据滚动位置高亮当前导航项
      this.updateActiveNav();
    },

    updateActiveNav() {
      const sections = ['home', 'overview', 'annotation', 'structure', 'contact'];
      const scrollPosition = window.scrollY + 150; // 偏移量

      sections.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          const offsetTop = element.offsetTop;
          const height = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + height) {
            // 可以在这里添加激活状态的逻辑
            const navItem = document.querySelector(`a[href="#${id}"]`);
            if (navItem) {
              document.querySelectorAll('.navbar-item').forEach(item => item.classList.remove('active'));
              navItem.classList.add('active');
            }
          }
        }
      });
    },

    openContactModal() {
      this.showContactModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeContactModal() {
      this.showContactModal = false;
      document.body.style.overflow = '';
    },

    submitContactForm() {
      const formData = {
        name: this.contactForm.name,
        gender: this.contactForm.gender,
        phone: this.contactForm.phone,
        company: this.contactForm.company,
        email: this.contactForm.email,
        position: this.contactForm.position,
        message: this.contactForm.message
      };

      const apiUrl = process.env.VUE_APP_API_BASE_URL;

      console.log('提交API地址:', apiUrl);
      console.log('提交数据:', formData);

      if (!apiUrl) {
        console.error('错误：未配置 VUE_APP_API_BASE_URL');
        this.showSuccessMessage('系统配置错误，请联系管理员');
        return;
      }

      fetch(`${apiUrl}/auto-annotate/contact/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
          .then(response => response.json())
          .then(data => {
            this.closeContactModal();
            if (data.code === 10000) {
              this.showSuccessMessage('提交成功！我们会尽快与您联系。');
              this.contactForm = {
                name: '',
                gender: '',
                phone: '',
                company: '',
                email: '',
                position: '',
                message: ''
              };
            } else {
              this.showSuccessMessage(data.message || '提交失败，请重试', true);
            }
          })
          .catch(error => {
            console.error('提交失败:', error);
            this.closeContactModal();
            this.showSuccessMessage('提交失败，请检查网络连接后重试', true);
          });
    },
    showSuccessMessage(message, isError = false) {
      const messageDiv = document.createElement('div');
      messageDiv.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        padding: 12px 24px;
        background: ${isError ? '#ef4444' : '#10b981'};
        color: white;
        border-radius: 8px;
        font-size: 16px;
        z-index: 99999;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        animation: slideDown 0.3s ease;
      `;
      messageDiv.textContent = message;
      document.body.appendChild(messageDiv);

      setTimeout(() => {
        messageDiv.style.animation = 'slideUp 0.3s ease';
        setTimeout(() => {
          document.body.removeChild(messageDiv);
        }, 300);
      }, 2000);
    },

    consultSales() {
      this.openContactModal();
    },

    switchLanguage() {
      // 跳转到英文版本页面
      window.location.href = 'http://szzx.sjj.tvzone.cn/multi-viewData-en/index/';
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80; // 导航栏高度
        const elementPosition = element.offsetTop - offset;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    },

    playIntroVideo() {
      this.scrollToSection('video-intro');
      setTimeout(() => {
        this.playVideo();
      }, 500);
    },

    // 视频播放控制方法
    playVideo() {
      this.$nextTick(() => {
        const video = this.$refs.introVideo;
        if (video) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.isPlaying = true;
              this.showControls = true;
            }).catch(error => {
              console.log('视频播放被阻止:', error);
              // 如果自动播放被阻止，只显示控制栏
              this.showControls = true;
            });
          }
        }
      });
    },

    togglePlayPause() {
      const video = this.$refs.introVideo;
      if (!video) return;

      if (video.paused) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
      this.showControls = true;
    },

    toggleMute() {
      const video = this.$refs.introVideo;
      if (!video) return;

      this.isMuted = !this.isMuted;
      video.muted = this.isMuted;
    },

    toggleFullscreen() {
      const video = this.$refs.introVideo;
      const container = video?.parentElement;
      if (!container) return;

      if (!document.fullscreenElement) {
        container.requestFullscreen().catch(err => {
          console.log('无法进入全屏模式:', err);
        });
      } else {
        document.exitFullscreen();
      }
    },

    seekVideo(event) {
      const video = this.$refs.introVideo;
      if (!video) return;

      const progressBar = event.currentTarget;
      const clickX = event.offsetX;
      const width = progressBar.offsetWidth;
      const percentage = clickX / width;

      video.currentTime = percentage * video.duration;
    },

    onVideoLoaded(videoType) {
      // 处理相机视频加载完成事件
      if (videoType && typeof videoType === 'string') {
        if (Object.prototype.hasOwnProperty.call(this.videoLoaded, videoType)) {
          this.videoLoaded[videoType] = true;
        }
        return;
      }

      // 处理介绍视频加载完成事件（兼容原有逻辑）
      const video = this.$refs.introVideo;
      if (!video) return;

      this.duration = this.formatTime(video.duration);
    },

    onTimeUpdate() {
      const video = this.$refs.introVideo;
      if (!video) return;

      this.currentTime = this.formatTime(video.currentTime);
      this.progressPercentage = (video.currentTime / video.duration) * 100;
    },

    onVideoEnded() {
      this.isPlaying = false;
      this.progressPercentage = 0;
    },

    formatTime(seconds) {
      if (isNaN(seconds)) return '0:00';

      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },

    goToMoreDetails() {
      // 跳转到详细页面并滚动到场景与动作详情
      this.$router.push('/details');
      setTimeout(() => {
        const sceneElement = document.getElementById('scene-action');
        if (sceneElement) {
          const offset = 80;
          const elementPosition = sceneElement.offsetTop - offset;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    },

    goToOneAct() {
      this.$router.push('/details').then(() => {
        setTimeout(() => {
          const element = document.getElementById('solo-action');
          if (element) {
            const offset = 80;
            const elementPosition = element.offsetTop - offset;
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      });
    },
    goToTwoAct() {
      this.$router.push('/details').then(() => {
        setTimeout(() => {
          const element = document.getElementById('two-interaction');
          if (element) {
            const offset = 80;
            const elementPosition = element.offsetTop - offset;
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      });
    },
    goToMultiAct() {
      this.$router.push('/details').then(() => {
        setTimeout(() => {
          const element = document.getElementById('multi-person');
          if (element) {
            const offset = 80;
            const elementPosition = element.offsetTop - offset;
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      });
    },

    // 初始化视频滚动播放观察器 - 实现视频预加载和滚动播放
    initVideoScrollObserver() {
      this.$nextTick(() => {
        const video = this.$refs.introVideo;
        if (!video) return;

        // 预加载视频
        video.preload = 'auto';
        video.load();

        // 方法1: 使用 IntersectionObserver (现代浏览器)
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                // 视频进入视口，尝试自动播放
                this.autoPlayIntroVideo();
              } else {
                // 视频离开视口，暂停播放
                if (!video.paused) {
                  video.pause();
                  this.isPlaying = false;
                }
              }
            });
          }, {
            threshold: 0.5, // 视频50%可见时触发
            rootMargin: '0px'
          });

          observer.observe(video);
          this.videoObserver = observer;
        } else {
          // 方法2: 使用滚动事件监听 (兼容性方案)
          this.handleIntroVideoScroll();
        }

        // 视频加载完成事件
        const onLoadedData = () => {
          console.log('视频预加载完成');
        };
        video.addEventListener('loadeddata', onLoadedData);
        // 保存引用以便清理
        this.videoLoadedDataHandler = onLoadedData;
      });
    },

    // 滚动事件处理 - 用于兼容不支持 IntersectionObserver 的浏览器
    handleIntroVideoScroll() {
      const video = this.$refs.introVideo;
      if (!video) return;

      const checkVideoVisibility = () => {
        const rect = video.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        // 计算视频在视口中的可见比例
        const visibleTop = Math.max(0, rect.top);
        const visibleBottom = Math.min(viewportHeight, rect.bottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visiblePercentage = (visibleHeight / Math.min(rect.height, viewportHeight)) * 100;

        // 如果视频50%以上可见，尝试播放
        if (visiblePercentage > 50) {
          this.autoPlayIntroVideo();
        } else {
          // 如果可见度低于50%，暂停播放
          if (!video.paused) {
            video.pause();
            this.isPlaying = false;
          }
        }
      };

      // 绑定滚动事件
      window.addEventListener('scroll', checkVideoVisibility, { passive: true });
      this.videoScrollHandler = checkVideoVisibility;

      // 初始检查
      checkVideoVisibility();
    },

    // 自动播放介绍视频 - 处理浏览器自动播放策略
    autoPlayIntroVideo() {
      const video = this.$refs.introVideo;
      if (!video || video.paused === false) return;

      // 设置静音以提高自动播放成功率
      if (!this.isMuted) {
        video.muted = true;
        this.isMuted = true;
      }

      // 尝试播放
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.then(() => {
          // 播放成功
          this.isPlaying = true;
          this.showControls = true;
          console.log('视频自动播放成功');
          // 移除视觉提示
          this.removePlayHint();
        }).catch(error => {
          // 播放失败，可能是浏览器策略限制
          console.log('视频自动播放被阻止:', error);
          // 显示控制栏，让用户手动播放
          this.showControls = true;
          // 移除静音状态
          video.muted = false;
          this.isMuted = false;
          // 添加视觉提示
          this.addPlayHint();
        });
      }
    },

    // 添加播放提示按钮
    addPlayHint() {
      this.$nextTick(() => {
        const video = this.$refs.introVideo;
        if (!video) return;

        const container = video.parentElement;
        if (!container || container.querySelector('.video-play-hint')) return;

        // 创建播放按钮提示
        const hint = document.createElement('div');
        hint.className = 'video-play-hint';
        hint.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 80px;
          background: rgba(220, 38, 38, 0.9);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 30px;
          cursor: pointer;
          z-index: 10;
          box-shadow: 0 10px 25px rgba(0,0,0,0.3);
          transition: transform 0.2s ease;
        `;
        hint.innerHTML = '▶';
        hint.onmouseenter = () => hint.style.transform = 'translate(-50%, -50%) scale(1.1)';
        hint.onmouseleave = () => hint.style.transform = 'translate(-50%, -50%) scale(1)';
        hint.onclick = () => {
          video.play().then(() => {
            hint.remove();
            this.isPlaying = true;
            this.showControls = true;
          });
        };
        container.style.position = 'relative';
        container.appendChild(hint);
      });
    },

    // 移除播放提示
    removePlayHint() {
      const video = this.$refs.introVideo;
      if (!video) return;

      const container = video.parentElement;
      if (container) {
        const hint = container.querySelector('.video-play-hint');
        if (hint) hint.remove();
      }
    },

    // 下载完整文档说明
    downloadDocument() {
      // 构建文件路径（相对于当前组件的路径）
      const filePath = './assets/dataset_structure_preview.txt';

      // 创建下载链接
      const link = document.createElement('a');
      link.href = filePath;
      link.download = 'dataset_structure_preview.txt';

      // 触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },


    // 动态加载 Plotly.js 脚本
    loadPlotlyScript() {
      // 检查是否已经加载
      if (window.Plotly) {
        this.plotlyLoaded = true;
        this.initPlotlyChart();
        return;
      }

      // 检查是否已经存在 script 标签
      const existingScript = document.querySelector('script[src*="plotly"]');
      if (existingScript) {
        // 如果 script 已存在但未加载完成，等待加载
        existingScript.addEventListener('load', () => {
          this.plotlyLoaded = true;
          this.initPlotlyChart();
        });
        return;
      }

      // 创建新的 script 标签
      const script = document.createElement('script');
      script.src = 'https://cdn.plot.ly/plotly-2.16.1.min.js';
      script.async = true;

      script.onload = () => {
        this.plotlyLoaded = true;
        this.initPlotlyChart();
      };

      script.onerror = () => {
        console.error('Failed to load Plotly.js');
      };

      document.head.appendChild(script);
    },

    // 初始化 Plotly 图表
    initPlotlyChart() {
      this.$nextTick(() => {
        if (!window.Plotly) {
          console.warn('Plotly not loaded yet');
          return;
        }

        const container = document.getElementById('plotly-action-viz');
        if (!container) {
          console.warn('Plotly container not found');
          return;
        }

        // 构建图表数据
        const data = [{
          type: "sunburst",
          branchvalues: this.plotlyData.branchvalues,
          ids: this.plotlyData.ids,
          labels: this.plotlyData.labels,
          parents: this.plotlyData.parents,
          values: this.plotlyData.values,
          customdata: this.plotlyData.customdata,
          marker: this.plotlyData.marker,
          hovertemplate: "labels=%{label}<br>Hours=%{value}<br>parent=%{parent}<br>id=%{id}<br>Scene=%{customdata[0]}<extra></extra>",
          name: ""
        }];

        // 构建布局配置
        const layout = {
          margin: { t: 20, l: 0, r: 0, b: 0 },
          font: {
            family: "'Noto Sans SC', sans-serif",
            size: 12
          },
          template: {
            data: {
              histogram2dcontour: [{ type: "histogram2dcontour", colorbar: { outlinewidth: 0, ticks: "" }, colorscale: [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}],
              choropleth: [{ type: "choropleth", colorbar: { outlinewidth: 0, ticks: "" } }],
              histogram2d: [{ type: "histogram2d", colorbar: { outlinewidth: 0, ticks: "" }, colorscale: [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}],
              heatmap: [{ type: "heatmap", colorbar: { outlinewidth: 0, ticks: "" }, colorscale: [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}],
              heatmapgl: [{ type: "heatmapgl", colorbar: { outlinewidth: 0, ticks: "" }, colorscale: [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}]
            }
          },
          showlegend: false,
          paper_bgcolor: 'rgba(0,0,0,0)',
          plot_bgcolor: 'rgba(0,0,0,0)'
        };

        const config = {
          responsive: true,
          displayModeBar: true,
          modeBarButtonsToAdd: ['hoverclosest', 'hovercompare'],
          displaylogo: false
        };

        // 初始化图表
        window.Plotly.newPlot('plotly-action-viz', data, layout, config);
      });
    },

    // 打开全屏饼图页面
    openFullscreenChart() {
      // 直接打开新窗口，不传递数据（数据已嵌入到 ChartFullscreen 组件中）
      // 这样可以避免 431 Request Header Fields Too Large 错误
      const routeData = this.$router.resolve({
        path: '/chart-fullscreen'
      });

      window.open(routeData.href, '_blank');
    },

    initVideo() {
      // 处理视频自动播放 - 超强增强版
      this.$nextTick(() => {
        const video = this.$refs.heroVideo;
        if (!video) {
          console.log('Hero视频元素未找到');
          return;
        }

        console.log('Hero视频初始化，readyState:', video.readyState, 'paused:', video.paused);

        // 强制静音（关键：浏览器策略要求）
        video.muted = true;
        video.setAttribute('muted', 'muted');

        // 预加载策略
        video.preload = 'auto';

        // 监听视频加载事件
        video.addEventListener('loadeddata', () => {
          console.log('Hero视频数据加载完成，readyState:', video.readyState);
          this.forceHeroVideoPlay();
        });

        video.addEventListener('canplay', () => {
          console.log('Hero视频可播放，readyState:', video.readyState);
          this.forceHeroVideoPlay();
        });

        // 尝试直接加载
        try {
          video.load();
        } catch (e) {
          console.log('视频load()调用异常:', e);
        }

        // 强制播放尝试 - 多次尝试
        this.forceHeroVideoPlay();

        // 延迟二次尝试（应对异步加载）
        setTimeout(() => {
          this.forceHeroVideoPlay();
        }, 500);

        // 三次尝试（应对复杂网络环境）
        setTimeout(() => {
          this.forceHeroVideoPlay();
        }, 1500);
      });
    },

    // 强制播放Hero视频
    forceHeroVideoPlay() {
      const video = this.$refs.heroVideo;
      if (!video) return;

      console.log('强制播放尝试 - readyState:', video.readyState, 'paused:', video.paused);

      // 如果已经在播放，跳过
      if (!video.paused) {
        console.log('Hero视频已在播放');
        return;
      }

      // 确保静音
      if (!video.muted) {
        video.muted = true;
        video.setAttribute('muted', 'muted');
      }

      // 尝试播放
      const playPromise = video.play();

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(() => {
          console.log('Hero视频播放成功！');
          this.removeHeroPlayHint();
        }).catch(error => {
          console.log('Hero视频播放失败:', error.name, error.message);
          // 播放失败时添加提示
          this.addHeroPlayHint();
        });
      } else {
        // play() 返回非promise，可能已经成功
        if (!video.paused) {
          console.log('Hero视频已开始播放（非promise返回）');
          this.removeHeroPlayHint();
        } else {
          console.log('Hero视频play()返回异常值');
          this.addHeroPlayHint();
        }
      }
    },

    // 尝试自动播放视频（保留兼容）
    attemptAutoPlay() {
      this.forceHeroVideoPlay();
    },

    // 添加主视频播放提示
    addHeroPlayHint() {
      this.$nextTick(() => {
        const video = this.$refs.heroVideo;
        if (!video) return;

        // 方案A: 添加全局点击事件监听（任何点击都触发播放）
        const enableVideoPlayback = () => {
          if (video.paused) {
            video.play().then(() => {
              console.log('点击触发播放成功');
              // 播放成功后移除监听器
              document.removeEventListener('click', enableVideoPlayback);
              document.removeEventListener('touchstart', enableVideoPlayback);
              // 移除视觉提示
              this.removeHeroPlayHint();
            }).catch(err => {
              console.log('点击播放仍然失败:', err);
            });
          }
        };

        // 同时监听点击和触摸事件（支持移动端）
        document.addEventListener('click', enableVideoPlayback, { once: false });
        document.addEventListener('touchstart', enableVideoPlayback, { once: false });

        // 创建播放提示覆盖层
        const overlay = document.createElement('div');
        overlay.innerHTML = `
          <div style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;z-index:3;cursor:pointer;">
            <div style="background:rgba(220,38,38,0.9);color:white;width:80px;height:80px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:30px;box-shadow:0 10px 25px rgba(0,0,0,0.3);">
              ▶
            </div>
          </div>
        `;
        overlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;';

        // 找到视频容器并添加覆盖层
        const container = video.parentElement;
        if (container && !container.querySelector('.video-play-hint')) {
          overlay.className = 'video-play-hint';
          overlay.style.pointerEvents = 'auto';
          overlay.style.cursor = 'pointer';
          overlay.onclick = () => {
            video.play().then(() => {
              overlay.remove();
              // 移除全局监听器
              document.removeEventListener('click', enableVideoPlayback);
              document.removeEventListener('touchstart', enableVideoPlayback);
            });
          };
          container.appendChild(overlay);
        }
      });
    },

    // 移除主视频播放提示
    removeHeroPlayHint() {
      const video = this.$refs.heroVideo;
      if (!video) return;

      const container = video.parentElement;
      if (container) {
        const hint = container.querySelector('.video-play-hint');
        if (hint) hint.remove();
      }
    },
  }
};
</script>

<style scoped>
/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page-container {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
}

/* 导航栏样式 */
.navbar {
  background: rgba(15, 23, 42, 0.95);
  border-bottom: 1px solid rgba(51, 65, 85, 1);
  transition: all 0.3s ease;
  z-index: 1000;
}

.navbar.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
}

.navbar.navbar-scrolled {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  background: rgba(15, 23, 42, 0.98);
}

.navbar-content {
  max-width: 1520px;
  margin: 0 auto;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.navbar-logo {
  width: 47px;
  height: 19px;
}

.navbar-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Noto Sans SC', sans-serif;
  white-space: nowrap;
}

.navbar-menu {
  display: flex;
  gap: 40px;
  align-items: center;
}

.navbar-item {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Noto Sans SC', sans-serif;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.navbar-item:hover,
.navbar-item.active {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

/* 页面内容区域 */
.page-content {
  margin-top: 0;
}

.section {
  width: 100%;
  padding: 80px 20px;
  position: relative;
}

.section-header {
  text-align: center;
  margin-bottom: 10px;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;
  font-family: 'Noto Sans SC', sans-serif;
}

.action-str-desc {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 20px;
}

.section-title-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.section-icon {
  width: 8px;
  height: 33px;
}

.badge {
  background: rgba(219, 234, 254, 1);
  color: rgba(37, 99, 235, 1);
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 700;
}

.section-subtitle {
  color: #64748b;
  font-size: 16px;
}

/* 首页区域 */
.hero-section {
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
  position: relative;
  overflow: hidden;
}

/* 视频背景 */
.hero-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

/* 视频覆盖层 - 增强文字可读性 */
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%);
  z-index: 1;
}

/* 如果视频加载失败，显示备用背景 */
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  z-index: -1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
}

.hero-title {
  font-size: 60px;
  font-weight: 700;
  margin-bottom: 24px;
  letter-spacing: -1.5px;
}

.hero-subtitle {
  font-size: 20px;
  color: #cbd5e1;
  margin-bottom: 40px;
  font-weight: 400;
  line-height: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.hero-subtitle .stat-line {
  display: block;
  color: #cbd5e1;
  letter-spacing: 0.3px;
}

.hero-subtitle strong {
  color: #ffffff;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.hero-subtitle .feature-tagline {
  display: inline-block;
  font-size: 1.1em;
  font-weight: 700;
  color: #ffffff;
  /* padding: 10px 20px; */
  border-radius: 8px;
  margin-top: 8px;
  letter-spacing: 0.5px;
}

/* 底部重点标语样式优化 */
.hero-subtitle.bottom {
  margin-top: 24px;
  margin-bottom: 0;
  gap: 0;
  width: 66.67%;
  margin-left: auto;
  margin-right: auto;
}

.hero-subtitle.bottom .feature-tagline {
  font-family: 'Noto Sans SC', 'Microsoft YaHei', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
  line-height: 1.6;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 9999px;
  backdrop-filter: blur(4px);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  display: inline-block;
  margin-top: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.hero-subtitle.bottom .feature-tagline:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.hero-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 16px 24px;
  border-radius: 9999px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  text-decoration: none;
}

.btn-primary {
  background: #dc2626;
  color: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
  background: #b91c1c;
  transform: translateY(-2px);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.2);
}

.btn-outline {
  background: white;
  color: #0f172a;
}

.btn-outline:hover {
  background: #f1f5f9;
  transform: translateY(-2px);
}

.scroll-indicator {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.5);
  font-size: 24px;
  cursor: pointer;
  animation: bounce 2s infinite;
  z-index: 2;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); }
  40% { transform: translateX(-50%) translateY(-10px); }
  60% { transform: translateX(-50%) translateY(-5px); }
}

/* 项目简介 */
.overview-section {
  background: #f1f5f9;
  max-width: 1400px;
  margin: 0 auto;
}

.data-details-section {
  background: #f1f5f9;
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 1px;
}

.overview-content {
  max-width: 864px;
  margin: 0 auto;
}

/* 移动端移除overview-content的宽度限制，让feature-cards可以占满屏幕 */
@media screen and (max-width: 768px) {
  .overview-content {
    max-width: 100%;
    width: 100%;
  }
}

.overview-description {
  font-size: 18px;
  line-height: 29px;
  color: #475569;
  text-align: center;
  margin-bottom: 48px;
}

.feature-cards {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
}

.feature-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 32px 24px;
  width: 267px;
  text-align: center;
  transition: transform 0.2s ease;
}

.feature-card:hover {
  transform: translateY(-4px);
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: #dbeafe;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 24px;
}

.feature-card h3 {
  font-size: 16px;
  color: #334155;
  margin-bottom: 8px;
}

.feature-card p {
  font-size: 14px;
  color: #64748b;
}

/* 移动端竖屏适配 - 强制3个卡片同行显示 */
@media screen and (max-width: 768px) {
  /* 重置所有父级容器的宽度限制 */
  .overview-section {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 40px 0 !important;
  }

  .overview-content {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* feature-cards 容器 - 强制3个同行 */
  .feature-cards {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 8px !important;
    padding: 0 8px !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: visible !important;
    justify-content: space-between !important;
    box-sizing: border-box !important;
  }

  /* 隐藏滚动条但保持功能 */
  .feature-cards::-webkit-scrollbar {
    display: none !important;
  }

  .feature-cards {
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
  }

  /* 每个卡片 - 占据1/3宽度 */
  .feature-card {
    flex: 1 1 33.333% !important;
    min-width: 0 !important;
    max-width: 33.333% !important;
    width: 33.333% !important;
    padding: 12px 6px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    flex-shrink: 0 !important;
  }

  .feature-icon {
    width: 28px !important;
    height: 28px !important;
    margin: 0 auto 8px !important;
    font-size: 14px !important;
  }

  .feature-card h3 {
    font-size: 12px !important;
    margin-bottom: 4px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .feature-card p {
    font-size: 10px !important;
    line-height: 1.2 !important;
    display: none !important;
  }
}

/* 小屏竖屏适配 - 保持3个同行 */
@media screen and (max-width: 430px) {
  .feature-cards {
    gap: 6px !important;
    padding: 0 6px !important;
  }

  .feature-card {
    flex: 1 1 33.333% !important;
    width: 33.333% !important;
    max-width: 33.333% !important;
    min-width: 0 !important;
    padding: 10px 4px !important;
  }

  .feature-icon {
    width: 24px !important;
    height: 24px !important;
    margin: 0 auto 6px !important;
    font-size: 12px !important;
  }

  .feature-card h3 {
    font-size: 11px !important;
  }

  .feature-card p {
    display: none !important;
  }
}

/* 超小屏适配 - 保持3个同行 */
@media screen and (max-width: 375px) {
  .feature-cards {
    gap: 4px !important;
    padding: 0 4px !important;
  }

  .feature-card {
    flex: 1 1 33.333% !important;
    width: 33.333% !important;
    max-width: 33.333% !important;
    min-width: 0 !important;
    padding: 8px 3px !important;
  }

  .feature-icon {
    width: 20px !important;
    height: 20px !important;
    margin: 0 auto 4px !important;
    font-size: 10px !important;
  }

  .feature-card h3 {
    font-size: 10px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .feature-card p {
    display: none !important;
  }
}

/* 视频介绍 */
.video-section {
  background: #f1f5f9;
  max-width: 1400px;
  margin: 0 auto;
}

.video-player {
  max-width: 992px;
  margin: 0 auto;
}

.video-container {
  background: rgba(15, 23, 42, 0.5);
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  height: 558px;
  display: flex;
  flex-direction: column;
}

/* 视频元素 */
.intro-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

/* 视频覆盖层 - 播放按钮 */
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.9) 100%);
  z-index: 2;
}

.play-button {
  width: 80px;
  height: 80px;
  border-radius: 9999px;
  background: #dc2626;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-button:hover {
  transform: scale(1.1);
}

/* 视频控制栏 */
.video-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, rgba(0,0,0,0.8) 0, rgba(0,0,0,0) 100%);
  padding: 20px;
  z-index: 3;
  transition: opacity 0.3s ease;
}

/* Logo标签 */
.logo-tag {
  display: inline-block;
  background: rgba(220, 38, 38, 0.9);
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Noto Sans SC', sans-serif;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

/* 进度条 */
.progress-bar {
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  margin-bottom: 12px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.progress-bar:hover {
  height: 6px;
}

.progress-fill {
  height: 100%;
  background: #dc2626;
  width: 0%;
  transition: width 0.1s linear;
}

/* 控制按钮区域 */
.control-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
}

.control-btn {
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  transition: opacity 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.control-btn:hover {
  opacity: 0.8;
}

.control-btn .active {
  color: #dc2626;
}

.time-display {
  font-size: 12px;
  margin-left: auto;
  white-space: nowrap;
}

/* 数据概览 */
.data-overview-section {
  background: #f8fafc;
  max-width: 1400px;
  margin: 0 auto;
}

/* 调整section-content和comparison-table之间的间距 */
.data-overview-section .section-content {
  margin-bottom: 60px;
}

.section-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  align-items: stretch;
}

/* section-content 内部字体自适应 - 保持原有布局 */
/* 1200px - 1440px 屏幕 */
@media (max-width: 1440px) and (min-width: 1200px) {
  .section-content .stat-value {
    font-size: 20px; /* 从22px减小 */
  }
  .section-content .stat-unit {
    font-size: 9px; /* 从10px减小 */
  }
  .section-content .stat-label {
    font-size: 11px; /* 从12px减小 */
  }
  .section-content .stat-detail {
    font-size: 11px; /* 从12px减小 */
  }
}

/* 1024px - 1199px 屏幕 */
@media (max-width: 1199px) and (min-width: 1024px) {
  .section-content .stat-value {
    font-size: 18px;
  }
  .section-content .stat-unit {
    font-size: 8px;
  }
  .section-content .stat-label {
    font-size: 10px;
  }
  .section-content .stat-detail {
    font-size: 10px;
  }
}

/* 768px - 1023px 屏幕 (平板) */
@media (max-width: 1023px) and (min-width: 768px) {
  .section-content .stat-value {
    font-size: 20px;
  }
  .section-content .stat-unit {
    font-size: 9px;
  }
  .section-content .stat-label {
    font-size: 11px;
  }
  .section-content .stat-detail {
    font-size: 11px;
  }
}

/* 480px - 767px 屏幕 (手机横屏/小平板) */
@media (max-width: 767px) and (min-width: 480px) {
  .section-content .stat-value {
    font-size: 22px;
  }
  .section-content .stat-unit {
    font-size: 10px;
  }
  .section-content .stat-label {
    font-size: 12px;
  }
  .section-content .stat-detail {
    font-size: 12px;
  }
}

/* 移动端竖屏专用优化 - 针对 section-content 减少屏占比和空白 */
@media (max-width: 480px) and (orientation: portrait) {
  /* 主容器优化 */
  .data-overview-section {
    padding: 20px 0; /* 减小整体内边距 */
  }

  /* section-content 核心优化 - 减少屏占比 */
  .section-content {
    gap: 6px; /* 进一步减小间距 */
    padding: 0 4px; /* 进一步减小边距 */
    margin-bottom: 20px; /* 减小底部外边距 */
  }

  /* 统计卡片密集布局 */
  .stats-grid {
    margin-bottom: 6px; /* 卡片间更紧凑 */
  }

  .stat-card {
    min-height: 120px; /* 进一步减小高度 */
    padding: 10px; /* 进一步减小内边距 */
  }

  .stat-icon,
  .stat-icon2,
  .stat-icon3,
  .stat-icon4 {
    width: 28px; /* 进一步减小 */
    height: 28px;
    font-size: 12px;
  }

  .stat-value {
    font-size: 20px; /* 进一步减小 */
  }

  .stat-unit {
    font-size: 10px;
  }

  .stat-label {
    font-size: 10px; /* 进一步减小 */
  }

  .stat-detail {
    font-size: 10px;
    padding: 1px 4px;
    margin-top: 4px;
  }

  /* 移动端竖屏：stat-value-label-wrapper 强制横向排列所有子元素 */
  .stat-value-label-wrapper {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    gap: 6px !important;
    width: 100% !important;
    overflow-x: visible !important;
    overflow-y: hidden !important;
    align-items: flex-start !important;
  }

  /* 移动端竖屏：stat-value-label 和 stat-value-label3 强制同行显示 */
  .stat-value-label,
  .stat-value-label3 {
    display: flex !important;
    flex-direction: column !important;
    flex: 1 1 0 !important;
    min-width: 0 !important;
    max-width: none !important;
    width: auto !important;
    overflow: visible !important;
  }

  /* 移动端竖屏：stat-value-container 强制横向显示 */
  .stat-value-container {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
    align-items: baseline !important;
    gap: 2px !important;
    white-space: nowrap !important;
    overflow: visible !important;
    width: auto !important;
    margin-bottom: 1px !important;
  }

  /* 移动端竖屏：stat-label 也调整为紧凑显示 */
  .stat-label {
    display: block !important;
    width: 100% !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
  }

  /* 特性盒子优化 */
  .feature-box {
    padding: 12px; /* 进一步减小 */
  }

  .box-header {
    margin-bottom: 8px;
  }

  .box-description {
    font-size: 12px;
    margin-bottom: 8px;
  }

  /* 场景概述优化 */
  .scene-overview {
    padding: 12px;
    margin-bottom: 12px;
  }

  .scene-overview-desc {
    font-size: 11px;
  }

  /* 特性卡片优化 */
  .feature-cards {
    gap: 6px;
    padding: 0 4px;
  }

  .feature-card {
    padding: 12px 8px;
  }

  .feature-icon {
    width: 32px;
    height: 32px;
    margin-bottom: 6px;
  }

  .feature-card h3 {
    font-size: 12px;
  }

  /* 高亮框优化 */
  .intro-highlight-box {
    padding: 12px;
    margin-bottom: 12px;
  }

  .highlight-item {
    padding: 10px;
  }

  .highlight-text {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .highlight-item p {
    font-size: 11px;
  }

  /* 效率部分优化 */
  .efficiency-section {
    padding: 12px;
    margin-bottom: 12px;
  }

  .efficiency-section .section-subtitle {
    font-size: 15px;
    margin-bottom: 6px;
  }

  .efficiency-description {
    font-size: 11px;
  }

  /* 动作集优化 */
  .action-set-container {
    padding: 8px;
  }

  .action-set-desc {
    font-size: 11px;
    margin-bottom: 8px;
  }

  /* Plotly 图表优化 */
  .plotly-container {
    height: 250px;
    padding: 6px;
  }

  .plotly-container div[id="plotly-action-viz"] {
    min-height: 200px;
  }

  /* 对比表格优化 */
  .comparison-table .table-row {
    padding: 8px 10px;
    gap: 4px;
  }

  .comparison-table .table-row.header {
    padding: 6px 10px;
  }

  .comparison-table .note-header {
    padding: 10px;
  }
}

/* 480px以下 屏幕 (手机竖屏) */
@media (max-width: 479px) {
  .section-content .stat-value {
    font-size: 24px;
  }
  .section-content .stat-unit {
    font-size: 11px;
  }
  .section-content .stat-label {
    font-size: 13px;
  }
  .section-content .stat-detail {
    font-size: 13px;
  }
}

/* 超宽屏 1920px+ */
@media (min-width: 1920px) {
  .section-content .stat-value {
    font-size: 23px;
  }
  .section-content .stat-unit {
    font-size: 11px;
  }
  .section-content .stat-label {
    font-size: 12px;
  }
  .section-content .stat-detail {
    font-size: 12px;
  }
}

/* 大屏幕布局优化 (1920px+) - 确保stat-value-label3正确显示 */
@media (min-width: 1920px) {
  .stat-value-label-wrapper {
    flex-direction: row !important;
  }
  .stat-value-label3 {
    flex: 1 1 calc(33.333% - 6px) !important;
    max-width: calc(33.333% - 6px) !important;
    min-width: 60px !important;
  }
  .stat-value-label {
    flex: 1 1 calc(50% - 6px) !important;
    max-width: calc(50% - 6px) !important;
    min-width: 80px !important;
  }
}

/* 2K 分辨率屏幕 (2048px - 3839px) - 专门适配 section-content */
@media (min-width: 2048px) and (max-width: 3839px) {
  .section-content .stat-value {
    font-size: 22px;
  }
  .section-content .stat-unit {
    font-size: 11px;
  }
  .section-content .stat-label {
    font-size: 12px;
  }
  .section-content .stat-detail {
    font-size: 12px;
  }
}

/* 4K 分辨率屏幕 (3840px+) - 专门适配 section-content */
@media (min-width: 3840px) {
  .section-content .stat-value {
    font-size: 16px;
  }
  .section-content .stat-unit {
    font-size: 8px;
  }
  .section-content .stat-label {
    font-size: 9px;
  }
  .section-content .stat-detail {
    font-size: 9px;
  }
}

.stats-grid {
  display: flex;
  flex: 1 1 220px;
  min-width: 220px;
  max-width: 280px;
  justify-content: center;
  margin-bottom: 0;
}

.stat-card {
  width: 97%;
  background: rgba(255,255,255,0.9);
  box-shadow: 0px 10px 25px -5px rgba(59,130,246,0.05), 0px 4px 10px -3px rgba(59,130,246,0.03);
  border-radius: 16px;
  border: 1px solid #FFFFFF;
  padding: 16px;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0; /* 防止卡片被压缩 */
  overflow: hidden; /* 防止内容溢出 */
}

/* 为 stat-icon 和后续的 label 创建一个水平容器 */
.stat-card > .stat-icon,
.stat-card > .stat-icon2,
.stat-card > .stat-icon3,
.stat-card > .stat-icon4 {
  align-self: flex-start;
}

.stat-card::after {
  content: '';
  display: table;
  clear: both;
}

.stat-icon {
  width: 40px;
  height: 40px;
  background: #EFF6FF;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 12px;
  border: 1px solid #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.stat-icon2 {
  width: 40px;
  height: 40px;
  background: #ECFDF5;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 12px;
  border: 1px solid #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.stat-icon3 {
  width: 40px;
  height: 40px;
  background: #F5F3FF;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 12px;
  border: 1px solid #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.stat-icon4 {
  width: 40px;
  height: 40px;
  background: #FFF1F2;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 12px;
  border: 1px solid #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.stat-icon img,
.stat-icon2 img,
.stat-icon3 img,
.stat-icon4 img {
  width: 20px;
  height: 20px;
}

/* 数据统计卡片内部样式 - 重构以解决 flex/inline-block 冲突 */

/* 统计值标签容器 - 用于包裹同行显示的 stat-value-label */
.stat-value-label-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  align-items: flex-start;
  flex-direction: row; /* 确保子元素横向排列 */
  overflow: visible; /* 防止内容被裁剪 */
}

/* 隐藏统计标签容器内的所有换行符，确保同行显示 */
.stat-value-label-wrapper br {
  display: none;
}

/* 单个统计值标签 (2个一组) - 使用flex确保同行显示 */
.stat-value-label {
  flex: 1 1 calc(50% - 4px);
  min-width: 100px;
  box-sizing: border-box;
  line-height: 1.2;
  max-width: calc(50% - 4px);
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止内容溢出 */
}

/* 单个统计值标签 (3个一组) - 使用flex确保同行显示 */
.stat-value-label3 {
  flex: 1 1 calc(33.333% - 6px);
  min-width: 60px;
  max-width: calc(33.333% - 6px);
  box-sizing: border-box;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止内容溢出 */
}

/* 统计值容器 */
.stat-value-container {
  width: 100%;
  display: flex;
  align-items: baseline;
  gap: 2px;
  margin-bottom: 2px;
  white-space: nowrap;
}

/* 统计数值 */
.stat-value {
  display: inline-block;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin-right: 2px;
  line-height: 1.1;
}

/* 统计单位 */
.stat-unit {
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  color: #94A3B8;
  line-height: 1;
  white-space: nowrap;
}

/* 统计标签 */
.stat-label {
  width: 100%;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 12px;
  color: #64748B;
  line-height: 1.2;
  text-align: left;
  font-style: normal;
  text-transform: none;
  white-space: normal;
  overflow: hidden; /* 防止文本溢出 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
}


.stat-detail {
  background: #eff6ff;
  color: #2563eb;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 12px;
  margin-top: 8px;
  display: inline-block;
  width: auto;
  white-space: nowrap;
  align-self: flex-start; /* 防止在flex容器中拉伸 */
  max-width: 100%; /* 确保不会超出父容器 */
  box-sizing: border-box;
}

.detail1 {
  color: #2563EB;
  background: #EFF6FF;
}

.detail2 {
  color: #059669;
  background: #ECFDF5;
}

.detail3 {
  color: #7C3AED;
  background: #F5F3FF;
}

.detail4 {
  color: #E11D48;
  background: #FFF1F2;
}

.stat-num {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.stat-name {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 12px;
}

/* 对比表格 */
.comparison-table {
  background: rgba(255,255,255,0.9);
  box-shadow: 0px 10px 25px -5px rgba(59,130,246,0.05), 0px 4px 10px -3px rgba(59,130,246,0.03);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  margin-top: 3%;
}

.comparison-table .table-header {
  background: white;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
}

.comparison-table .table-header .w_first {
  display: flex;
  align-items: center;
  gap: 8px;
}

.comparison-table .table-header .w_1 {
  width: 8px;
  height: 24px;
  background: #2563EB;
  border-radius: 9999px;
  flex-shrink: 0;
}

.comparison-table .table-header .w_title {
  height: 22px;
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 20px;
  color: #1E293B;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  white-space: nowrap;
}

.comparison-table .table-content {
  overflow-x: auto;
  background: white;
}

.comparison-table .table-row {
  display: grid;
  grid-template-columns: 25% 12% 12% 15% 12% 14%;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  align-items: center;

  font-family: Inter, Inter;
  font-weight: normal;
  font-size: 14px;
  color: #334155;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.comparison-table .table-row > span {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

.comparison-table .table-row > span:not(:first-child) {
  text-align: center;
}

.comparison-table .table-row.header {
  background: #f8fafc;
  font-weight: 600;
  color: #64748b;
  padding: 12px 24px;
}

.comparison-table .table-row.highlight {
  background: #eff6ff;
  border: 2px solid #bfdbfe;
  font-weight: 1000;
}

.comparison-table .our-text {
  color: #2563eb;
}

/* 环境字段样式 - 根据真实场景/实验室显示不同样式 */
.comparison-table .env-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  line-height: 1;
  margin: 0 auto;
}

.comparison-table .env-badge.real-world {
  width: 70px;
  height: 24px;
  background: #EEF2FF;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #E0E7FF;
  color: #4F46E5;
}

.comparison-table .env-badge.lab {
  width: 58px;
  height: 24px;
  background: #F1F5F9;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #E2E8F0;
  color: #64748B;
}

.comparison-table .legend {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: nowrap;
}

.comparison-table .legend .l_dot1 {
  width: 10px;
  height: 10px;
  background: #3B82F6;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 9999px;
  flex-shrink: 0;
}

.comparison-table .legend-item.our {
  width: 52px;
  height: 14px;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 12px;
  color: #334155;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  flex-shrink: 0;
}

.comparison-table .legend .l_dot2 {
  width: 10px;
  height: 10px;
  background: #CBD5E1;
  border-radius: 9999px;
  flex-shrink: 0;
}

.comparison-table .legend-item.other {
  width: 28px;
  height: 14px;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 12px;
  color: #334155;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  flex-shrink: 0;
}

/* 说明框 - 作为comparison-table的子元素 */
.comparison-table .note-box {
  background: #f8fafc;
  padding: 20px;
  border-top: 1px solid #e2e8f0;
  border-radius: 0 0 16px 16px;
}

.comparison-table .note-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 12px;
  line-height: 1.4;
  color: #475569;
}

.comparison-table .note-footer {
  font-size: 12px;
  color: #64748b;
  padding-left: 62px;
  line-height: 1.4;
}

.comparison-table .tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}

.comparison-table .tag.our {
  background: #dbeafe;
  color: #2563eb;
}

.comparison-table .tag.fixed {
  background: #e2e8f0;
  color: #475569;
}

.comparison-table .tag.movable {
  background: #dbeafe;
  color: #2563eb;
}

/* 数据集对比表格中的镜头类型标签 */
.camera-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 3px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 1000;
  margin-left: 1px;
  border: 1px solid;
  white-space: nowrap;
  height: 18px;
  line-height: 1;
  flex-shrink: 0;
  position: relative;
  top: 0;
}

.camera-tag.fixed {
  background: #e2e8f0;
  color: #475569;
  border-color: #cbd5e1;
}

.camera-tag.movable {
  background: #dbeafe;
  color: #2563eb;
  border-color: #93c5fd;
}


/* 第一列容器 - 确保内容可以正确展开 */
.comparison-table .table-row > span:first-child {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 6px !important;
  overflow: visible !important;
  white-space: nowrap;
  width: 100%;
  height: auto;
  min-height: 20px;
  text-align: left;
  font-weight: bold;
}

/* 第一列内的名称文本 */
.comparison-table .table-row > span:first-child > span:first-child {
  white-space: nowrap;
  overflow: visible;
  flex-shrink: 1;
  min-width: 0;
}

/* 第一列内的camera-tag - 确保在名称右侧正确显示 */
.comparison-table .table-row > span:first-child .camera-tag {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  white-space: nowrap !important;
  overflow: visible !important;
  flex-shrink: 0 !important;
  height: 18px !important;
  min-width: 40px !important;
  padding: 1px 4px !important;
  border-radius: 4px !important;
  font-size: 10px !important;
  font-weight: 1000 !important;
  border: 1px solid !important;
  position: relative !important;
  top: 0 !important;
  margin-left: 4px !important;
}

.comparison-table .table-row > span:first-child .camera-tag.fixed {
  background: #e2e8f0 !important;
  color: #475569 !important;
  border-color: #cbd5e1 !important;
}

.comparison-table .table-row > span:first-child .camera-tag.movable {
  background: #dbeafe !important;
  color: #2563eb !important;
  border-color: #93c5fd !important;
}

/* 特性盒子 */
.features-section {
  background: #f8fafc;
  max-width: 1400px;
  margin: 0 auto;
}

.feature-boxes {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 3%;
}

.feature-box {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 16px;
  padding: 24px;
  flex: 1;
  min-width: 0;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.03);
  border: 1px solid rgba(255, 255, 255, 1);
}

.box-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 18px;
  color: #1E293B;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;

}

.box-header h3 {
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 18px;
  color: #1E293B;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.box-icon {
  width: 40px;
  height: 40px;
  background: #f0f9ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.box-description {
  font-size: 14px;
  line-height: 16px;
  color: #64748b;
  margin-bottom: 16px;
}

.box-tags {
  display: flex;
  gap: 8px;
}

.box-tags .tag {
  background: #eff6ff;
  color: #2563eb;
  padding: 4px 8px;
  font-size: 12px;
}

.tags2 .tag {
  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 12px;
  color: #9333EA;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

/* 分布图表 - 饼图 */
.distribution-chart {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 160px; /* 确保最小高度，防止布局塌陷 */
}

/* 饼图容器 */
.pie-chart {
  position: relative;
  width: 160px;
  height: 160px;
  min-width: 120px;
  min-height: 120px;
  border-radius: 50%;
  background: #f1f5f9;
  overflow: hidden;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
}

/* 饼图切片 - 使用conic-gradient实现，添加1px白色间隔线 */
.pie-chart::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: conic-gradient(
    #3b82f6 0deg 259.2deg,
    white 259.2deg 260.4deg,
    #8b5cf6 260.4deg 324deg,
    white 324deg 325.2deg,
    #ec4899 325.2deg 360deg
  );
  border-radius: 50%;
}

/* 图例样式 */
.chart-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 180px;
  font-size: 12px;
  padding-left: 5%;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  flex-shrink: 0;
}

.legend-color.single { background: #3b82f6; }
.legend-color.double { background: #8b5cf6; }
.legend-color.multi { background: #ec4899; }

/* 场景多样性 */
.scene-diversity {
  margin-top: 30px;
}

.scene-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 700;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  overflow: hidden;
}

.scene-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  flex-wrap: nowrap;
  white-space: nowrap;
  flex-shrink: 1;
  max-width: calc(100% - 60px); /* 为按钮预留空间 */
}

.scene-header .h_1 {
  width: 6px;
  height: 24px;
  background: #10B981;
  border-radius: 9999px 9999px 9999px 9999px;
}

.scene-header .h_title {
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 20px;
  color: #1E293B;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  min-width: 0; /* 允许在必要时压缩 */
}

.set-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
  max-width: 60%;
  flex-shrink: 1;
  min-width: 0;
  width: auto; /* 自动宽度 */
}

.scene-time {
  padding: 4px 8px;
  font-size: 14px;
  color: #2563eb;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
}

.more-btn {
  background: #f1f5f9;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #64748b;
  margin-left: auto;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  font-weight: 500;
  letter-spacing: 0.5px;
  flex-shrink: 0;
  white-space: nowrap;
}

/* 基础动效 - 悬停状态 */
.more-btn:hover {
  background: #2563eb;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

/* 点击动效 */
.more-btn:active {
  transform: translateY(0) scale(0.95);
}

/* 点击波纹效果 */
.more-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.more-btn:active::after {
  width: 200px;
  height: 200px;
}

/* 脉冲动画 - 吸引注意力 */
@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(37, 99, 235, 0);
  }
}

/* 第一个按钮（场景多样性）添加脉冲提示 */
.morebtn0 {
  background: white;
  border: 1px solid #e2e8f0;
  animation: pulse 2s infinite;
  overflow: visible !important; /* 允许slide-track动画完全显示 */
  position: relative;
  width: auto;
  min-width: 30px;
}

.morebtn0:hover {
  animation: none;
  background: #2563eb;
  color: white;
  border-color: #2563eb;
}

.slide-track {
  position: relative;
  height: 24px;
  width: 100%;
  min-width: 30px;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.slide-track span {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 35px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  text-align: center;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  display: block;
  box-sizing: border-box;
}

/* 确保span元素有明确的宽度，防止宽度为0 */
.slide-track span {
  width: 100%;
  min-width: 30px;
}

.slide-track span:first-child {
  animation: slide-track-first 3s infinite ease-in-out;
}

.slide-track span:last-child {
  animation: slide-track-second 3s infinite ease-in-out;
}

@keyframes slide-track-first {
  0%, 45% {
    opacity: 1;
    transform: translateY(0);
  }
  50%, 100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

@keyframes slide-track-second {
  0%, 45% {
    opacity: 0;
    transform: translateY(10px);
  }
  50%, 95% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

/* 移动端竖屏适配 */
@media (max-width: 768px) and (orientation: portrait) {
  .slide-track {
    height: 24px;
    margin: 0;
    overflow: hidden;
  }
  .slide-track span {
    height: 24px;
    line-height: 24px;
    font-size: 13px;
  }

  /* 移动端竖屏按钮基础样式优化 */
  .more-btn {
    min-width: 35px; /* 确保最小宽度 */
    height: auto; /* 高度自适应 */
    padding: 8px 10px; /* 调整内边距 */
    font-size: 12px; /* 适配移动端字体 */
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap; /* 防止文字换行 */
  }

  /* morebtn0 在移动端竖屏的特殊处理 */
  .morebtn0 {
    padding: 8px 10px;
    min-width: 55px;
    animation: pulse-mobile 2s infinite; /* 移动端专用脉冲动画 */
    overflow: visible !important; /* 确保slide-track动画可见 */
  }

  /* 移动端脉冲动画 - 更温和 */
  @keyframes pulse-mobile {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.3);
    }
    50% {
      box-shadow: 0 0 0 6px rgba(37, 99, 235, 0);
    }
  }
}

/* 小屏幕竖屏适配 (iPhone SE, 小屏Android) */
@media (max-width: 480px) and (orientation: portrait) {
  .slide-track {
    height: 24px; /* 保持一致 */
    overflow: visible !important;
  }
  .slide-track span {
    height: 24px;
    line-height: 24px;
    font-size: 11px;
  }

  /* 小屏幕按钮进一步优化 */
  .more-btn {
    min-width: 45px;
    padding: 6px 8px;
    font-size: 11px;
  }

  .morebtn0 {
    min-width: 35px;
    padding: 6px 8px;
    animation: pulse-small 2s infinite;
  }

  /* 超小屏幕脉冲动画 */
  @keyframes pulse-small {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.25);
    }
    50% {
      box-shadow: 0 0 0 4px rgba(37, 99, 235, 0);
    }
  }

  /* 小屏幕头部样式优化 - 强制同行 */
  .scene-header,
  .action-header {
    font-size: 14px;
    gap: 6px;
    flex-wrap: nowrap !important; /* 强制不换行 */
  }

  .scene-header-left {
    min-width: 100px;
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    max-width: calc(100% - 50px);
  }

  .scene-header .h_title {
    font-size: 14px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
    min-width: 0;
  }

  .action-header span:first-child {
    min-width: 70px;
    flex-shrink: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 100px); /* 为时间和按钮预留空间 */
  }

  .action-time {
    font-size: 10px;
    padding: 2px 4px;
    flex-shrink: 0;
  }

  .set-desc {
    font-size: 11px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 1 auto;
    max-width: 40%;
    flex-shrink: 1;
    min-width: 0;
    width: auto;
  }

  /* 确保按钮在小屏幕上不会挤压内容 */
  .more-btn {
    flex-shrink: 0;
    min-width: 45px; /* 保持最小宽度 */
  }

  /* 极小屏幕适配 (宽度 < 380px) */
  @media (max-width: 380px) and (orientation: portrait) {
    .more-btn > span {
      display: none; /* 只隐藏直接子元素的span，不影响slide-track内部的span */
    }
    .more-btn {
      min-width: 40px;
      padding: 6px;
    }
    /* 保持轮播效果 */
    .morebtn0 .slide-track span {
      height: 24px;
      line-height: 24px;
      font-size: 10px;
    }
  }
}

/* 高DPI屏幕适配 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .slide-track {
    transform: translateZ(0); /* 启用硬件加速 */
    backface-visibility: hidden;
    perspective: 1000px;
  }
}

/* 渐变背景动效 */
.more-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.more-btn:hover::before {
  left: 100%;
}

/* 边框发光效果 */
.more-btn {
  border: 1px solid transparent;
}

.more-btn:hover {
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* 文字滑动效果 - 仅作用于直接子元素的span，不影响slide-track内部的span */
.more-btn > span {
  display: inline-block;
  transition: transform 0.3s ease;
}

.more-btn:hover > span {
  transform: translateX(2px);
}

/* 确保slide-track在morebtn0中正常工作 */
.morebtn0 .slide-track {
  overflow: hidden;
  position: relative;
  width: 100%;
  min-width: 35px;
}

/* 防止more-btn的overflow:hidden影响slide-track动画 */
.morebtn0 {
  overflow: visible !important;
}

/* 按钮组动效 - 差异化设计 */

/* 场景多样性按钮 - 温和提示 */
.morebtn0 {
  position: relative;
}

.morebtn0::before {
  content: '✨';
  position: absolute;
  right: 8px;
  opacity: 0;
  transform: translateX(-5px);
  transition: all 0.3s ease;
}

.morebtn0:hover::before {
  opacity: 1;
  transform: translateX(0);
}

/* 单人动作按钮 - 活力橙色 */
.more-btn:nth-of-type(1) {
  background: #fff7ed;
  color: #c2410c;
}

.more-btn:nth-of-type(1):hover {
  background: #ea580c;
  color: white;
}

/* 双人动作按钮 - 紫色渐变 */
.more-btn:nth-of-type(2) {
  background: #f5f3ff;
  color: #7c3aed;
}

.more-btn:nth-of-type(2):hover {
  background: linear-gradient(135deg, #7c3aed, #a78bfa);
  color: white;
}

/* 多人动作按钮 - 红色能量 */
.more-btn:nth-of-type(3) {
  background: #fef2f2;
  color: #dc2626;
}

.more-btn:nth-of-type(3):hover {
  background: linear-gradient(135deg, #dc2626, #ef4444);
  color: white;
  transform: translateY(-2px) scale(1.05);
}

/* 悬停时的图标动画 */
.more-btn::before {
  content: '→';
  margin-right: 4px;
  display: inline-block;
  transition: transform 0.3s ease;
}

.more-btn:hover::before {
  transform: translateX(4px);
}

/* 禁用动画（减少动效偏好） */
@media (prefers-reduced-motion: reduce) {
  .more-btn,
  .more-btn::before,
  .more-btn::after {
    transition: none;
    animation: none;
  }
}

/* 移动端优化 - 通用 */
@media (max-width: 768px) {
  .more-btn {
    padding: 8px 12px;
    font-size: 13px;
    min-width: 48px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .more-btn:hover {
    transform: translateY(-1px);
  }

  /* morebtn0 移动端通用优化 */
  .morebtn0 {
    padding: 8px 12px;
    min-width: 52px;
  }

  /* action-header 在移动端的适配 - 保持同行 */
  .action-header {
    font-size: 16px;
    flex-wrap: nowrap; /* 强制不换行 */
    gap: 8px;
    min-height: 40px; /* 确保最小高度 */
    width: 100%;
    overflow: hidden;
  }

  .action-header span:first-child {
    flex-shrink: 1; /* 允许文字收缩 */
    min-width: 80px; /* 但保持最小宽度 */
    max-width: calc(100% - 120px); /* 为时间和按钮预留空间 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .action-time {
    font-size: 11px;
    padding: 3px 6px;
    margin-left: 0; /* 移除左边距，使用gap */
    flex-shrink: 0; /* 不收缩 */
  }

  /* 确保按钮在 action-header 中正确对齐 */
  .action-header .more-btn {
    margin-left: auto;
    transform: none !important; /* 移除悬停位移避免布局跳动 */
    flex-shrink: 0; /* 不收缩 */
  }

  /* scene-header 在移动端的适配 - 保持同行 */
  .scene-header {
    font-size: 16px;
    flex-wrap: nowrap; /* 强制不换行 */
    gap: 8px;
    min-height: 44px; /* 确保最小高度 */
  }

  .scene-header-left {
    flex: 1 1 auto;
    min-width: 120px;
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    max-width: calc(100% - 55px); /* 为按钮预留空间 */
  }

  .scene-header .h_title {
    font-size: 16px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
    min-width: 0;
  }

  .scene-header .more-btn {
    margin-left: auto;
    transform: none !important;
    flex-shrink: 0;
  }

  .set-desc {
    font-size: 12px !important;
    margin: 0 !important;
    line-height: 1.4 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 1 auto;
    max-width: 50%;
    flex-shrink: 1;
    min-width: 0;
    width: auto;
  }
}

/* 横屏适配 - 必须放在通用移动端样式之后以确保优先级 */
@media (max-width: 768px) and (orientation: landscape) {
  /* 按钮基础样式 - 覆盖通用移动端样式 */
  .more-btn {
    min-width: 42px !important;
    height: 32px !important;
    padding: 6px 12px !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    white-space: nowrap !important;
    overflow: visible !important;
    background: #f1f5f9 !important;
    border: 1px solid #e2e8f0 !important;
  }

  .morebtn0 {
    min-width: 46px !important;
    width: 46px !important;
    height: 32px !important;
    padding: 6px 8px !important;
    overflow: visible !important;
    background: white !important;
    border: 1px solid #e2e8f0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
  }

  /* 确保slide-track在横屏下有固定宽度 */
  .morebtn0 .slide-track {
    overflow: visible !important;
    position: relative;
    height: 24px !important;
    width: 35px !important;
    min-width: 35px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  /* Slide-track 轮播样式 - 确保在横屏下正常显示 */
  .slide-track {
    position: relative;
    height: 24px;
    width: 35px !important;
    min-width: 35px !important;
    overflow: visible !important;
    margin: 0;
    padding: 0;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .slide-track span {
    position: absolute;
    top: 0;
    left: 0;
    width: 35px !important;
    min-width: 35px !important;
    max-width: 35px !important;
    height: 24px !important;
    line-height: 24px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    white-space: nowrap !important;
    text-align: center !important;
    opacity: 0 !important;
    display: block !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    background: transparent !important;
  }

  /* 横屏专用动画 - 使用translateY进行位移 */
  .slide-track span:first-child {
    animation: slide-track-first-landscape 3s infinite ease-in-out !important;
  }

  .slide-track span:last-child {
    animation: slide-track-second-landscape 3s infinite ease-in-out !important;
  }

  /* 隐藏可能干扰的伪元素 */
  .morebtn0::before {
    display: none !important;
  }
}

/* 横屏专用关键帧动画 */
@keyframes slide-track-first-landscape {
  0%, 45% {
    opacity: 1;
    transform: translateY(0);
  }
  50%, 100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

@keyframes slide-track-second-landscape {
  0%, 45% {
    opacity: 0;
    transform: translateY(10px);
  }
  50%, 95% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.scene-images {
  display: flex;
  gap: 16px;
  background: white;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.03);
}

.scene-image {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  background: #f1f5f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  position: relative;
  overflow: hidden;
}

.scene-image .action-header {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(255, 255, 255, 0.95);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.scene-image .action-header-tip {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(255, 255, 255, 0.85);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #000000;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.scene-image .action-header-tip span {
  color: #000000;
  opacity: 0.9;
}

.camera-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
  border-radius: 4px;
  display: block;
}

.modal-content {
  width: 95%;
  max-width: 100%;
}

.modal-header {
  padding: 16px;
}

.modal-title {
  font-size: 20px;
}

.modal-body {
  padding: 16px;
}

.camera-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

/* 动作类型 */
.action-types-section {
  background: #f8fafc;
  max-width: 1400px;
  margin: 0 auto;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-top: 48px;
}

.action-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.03);
  border: 1px solid rgba(255, 255, 255, 1);
}

.action-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 18px;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  overflow: hidden;
}

.action-time {
  background: #eff6ff;
  color: #2563eb;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  flex-shrink: 0;
  white-space: nowrap;
}

.action-preview {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.preview-placeholder {
  flex: 1;
  height: 182px;
  background: #f1f5f9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 12px;
}

.score-box {
  background: #000;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.score-value {
  background: #facc15;
  color: #422006;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 700;
}

.score-demo {
  color: #fff;
  font-size: 12px;
}

.score-description {
  font-size: 14px;
  color: #64748b;
  line-height: 16px;
}

.action-image {
  height: 132px;
  background: #f1f5f9;
  border-radius: 8px;
  margin-top: 12px;
}

/* 统计数据 */
.stats-section {
  background: white;
  max-width: 1400px;
  margin: 0 auto;
}

.stats-row {
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.stat-item {
  background: #f8fafc;
  border-radius: 12px;
  padding: 24px 32px;
  min-width: 200px;
  text-align: center;
}

.stat-item.large {
  background: white;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.03);
  border: 1px solid rgba(255, 255, 255, 1);
}

.stat-icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.stat-num {
  font-size: 30px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.stat-name {
  font-size: 14px;
  color: #64748b;
}

/* 视频标注 */
.annotation-section {
  background: #f8fafc;
  max-width: 1400px;
  margin: 0 auto;
}

.annotation-content {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 48px;
}

.annotation-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 600px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.annotation-card h3 {
  margin-bottom: 16px;
  padding-left: 16px;
  border-left: 4px solid #dc2626;
}

.id-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.id-item {
  background: #f1f5f9;
  padding: 52px 0;
  border-radius: 4px;
  text-align: center;
  color: #94a3b8;
  font-weight: 700;
}

.smpl-view {
  background: #1e293b;
  border-radius: 8px;
  padding: 100px 0;
  text-align: center;
  color: white;
  font-size: 18px;
  margin-bottom: 16px;
}

.annotation-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 20px;
}

/* 数据集结构 */
.structure-section {
  background: #f1f5f9;
  max-width: 1400px;
  margin: 0 auto;
}

.structure-content {
  background: #0f172a;
  border-radius: 12px;
  padding: 24px;
  max-width: 1120px;
  margin: 0 auto 0;
  color: white;
}

.file-header {
  background: #1e293b;
  padding: 8px 16px;
  border-bottom: 1px solid #334155;
  font-family: Menlo, monospace;
  font-size: 11px;
  color: #94a3b8;
}

.tree-view {
  font-family: Menlo, monospace;
  font-size: 13px;
  line-height: 20px;
  padding: 24px;
  overflow-x: auto;
}

.tree-line {
  white-space: nowrap;
}

.tree-line:nth-child(1) { color: #4ade80; }
.tree-line:nth-child(2) { color: #60a5fa; }
.tree-line:nth-child(3), .tree-line:nth-child(4) { color: #facc15; }
.tree-line:nth-child(5), .tree-line:nth-child(6) { color: #6063fa; }
.tree-line:nth-child(7) { color: #60a5fa; }
.tree-line:nth-child(8), .tree-line:nth-child(9), .tree-line:nth-child(10), .tree-line:nth-child(11){ color: #facc15; }
.tree-line:nth-child(12) { color: #60a5fa; }
.tree-line:nth-child(13) { color: #60a5fa; }
.tree-line:nth-child(14) { color: #6063fa; }
.tree-line:nth-child(15) { color: #6063fa; }
.tree-line:nth-child(16), .tree-line:nth-child(17), .tree-line:nth-child(18), .tree-line:nth-child(19) ,
.tree-line:nth-child(20), .tree-line:nth-child(21), .tree-line:nth-child(22){ color: #fa60ed; }
.tree-line:nth-child(23), .tree-line:nth-child(24) { color: #6063fa; }


.compliance-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(234, 179, 8, 0.1);
  color: #eab308;
  padding: 12px;
  border-radius: 4px;
  margin: 24px 0;
  font-size: 14px;
}

.download-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
  transition: all 0.2s ease;
}

.download-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 联系我们 */
.contact-section {
  background: #0f172a;
  color: white;
  max-width: 1400px;
  margin: 0 auto;
}

.contact-content {
  display: flex;
  gap: 48px;
  justify-content: center;
  align-items: center;
  margin-bottom: 48px;
  flex-wrap: wrap;
}

.contact-info {
  min-width: 584px;
}

.contact-info h3 {
  margin-bottom: 24px;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: bold;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;

  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: normal;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contact-emails {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  color: #cbd5e1;
  font-size: 16px;
  flex-wrap: wrap;
}

.contact-address {
  color: #cbd5e1;
  margin-left: 28px;

  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: normal;
  font-size: 16px;
  color: #CBD5E1;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contact-links {
  margin-top: 32px;
}

.link-group {
  display: flex;
  gap: 16px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.link-item {
  color: #cbd5e1;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

.link-item:hover {
  color: white;
}

.contact-qr {
  width: 584px;
  height: 375px;
  background: #1e293b;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.feishu-item {
  margin-top: 16px;
}

.feishu-qr {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-left: 28px;
  margin-top: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.feishu-qr:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.feishu-qr-small {
  width: 80px;
  height: 80px;
}

.address-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  /* opacity: 0.6; */
}

.footer {
  border-top: 1px solid #334155;
  padding-top: 32px;

  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 14px;
  color: #64748B;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .navbar-menu {
    gap: 20px;
  }

  .table-row {
    grid-template-columns: 30% 10% 10% 10% 10% 10% 10%;
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .navbar-content {
    flex-direction: column;
    height: auto;
    gap: 12px;
    padding: 12px;
  }

  .navbar-menu {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }

  .navbar-item {
    font-size: 12px;
    padding: 6px 8px;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 18px;
    line-height: 1.8;
    gap: 10px;
  }

  .hero-subtitle strong {
    padding: 2px 6px;
  }

  .hero-subtitle .feature-tagline {
    font-size: 1em;
    padding: 8px 12px;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }

  .section {
    padding: 40px 16px;
  }

  .section-title {
    font-size: 28px;
  }

  .section-content {
    flex-direction: column;
    gap: 16px;
  }

  .stats-grid {
    width: 100%;
    max-width: 400px;
    min-width: auto;
  }

  /* feature-cards 已在上面定义为3个同行显示，此处删除冲突样式 */

  .action-grid {
    grid-template-columns: 1fr;
  }

  .annotation-card {
    width: 100%;
  }

  .contact-info {
    min-width: auto;
    width: 100%;
  }

  /* 饼图响应式 - 768px以下 */
  .distribution-chart {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .pie-chart {
    width: 140px;
    height: 140px;
  }

  .chart-legend {
    padding-left: 0;
    text-align: center;
    min-width: auto;
  }

  .comparison-table {
    background: rgba(255,255,255,0.9);
    box-shadow: 0px 10px 25px -5px rgba(59,130,246,0.05), 0px 4px 10px -3px rgba(59,130,246,0.03);
    border-radius: 16px 16px 16px 16px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
    margin-bottom: 16px;
  }

  .hero-subtitle {
    font-size: 14px;
    line-height: 1.6;
    gap: 8px;
  }

  .hero-subtitle .stat-line {
    padding: 2px 0;
  }

  .hero-subtitle strong {
    font-size: 0.95em;
    padding: 1px 6px;
  }

  .hero-subtitle .feature-tagline {
    font-size: 0.9em;
    padding: 8px 8px;
    margin-top: 4px;
  }

  .hero-actions {
    flex-direction: column;
    gap: 10px;
  }

  .btn {
    width: 100%;
    max-width: 280px;
    padding: 14px 20px;
    font-size: 14px;
  }

  .section-title {
    font-size: 24px;
  }

  /* 移动端竖屏优化 - 减少section-content屏占比和空白 */
  .section-content {
    gap: 8px; /* 减小卡片间距 */
    margin: 0 auto;
    padding: 0 8px; /* 减少左右边距 */
  }

  .data-overview-section .section-content {
    margin-bottom: 30px; /* 减小底部间距 */
  }

  .stats-grid {
    min-width: 100%;
    flex: 1 1 100%; /* 占满宽度 */
    margin-bottom: 8px; /* 减小卡片底部间距 */
  }

  .stat-card {
    min-height: 140px; /* 减小卡片高度 */
    padding: 12px; /* 减小内边距 */
    gap: 4px; /* 减小内部元素间距 */
  }

  .stat-icon,
  .stat-icon2,
  .stat-icon3,
  .stat-icon4 {
    width: 32px; /* 减小图标尺寸 */
    height: 32px;
    margin-bottom: 4px; /* 减小图标底部间距 */
    font-size: 14px;
  }

  .stat-value-label-wrapper {
    flex-direction: column;
    gap: 8px; /* 减小标签组间距 */
  }

  .stat-value-label,
  .stat-value-label3 {
    flex: 1 1 100%;
    min-width: 100%;
  }

  .stat-value-container {
    gap: 2px; /* 减小数值和单位间距 */
    margin-bottom: 1px; /* 减小数值容器底部间距 */
  }

  .stat-num {
    font-size: 22px; /* 稍微减小 */
  }

  .stat-value {
    font-size: 22px; /* 稍微减小 */
  }

  .stat-unit {
    font-size: 11px;
  }

  .stat-label {
    font-size: 11px; /* 减小标签字体 */
    line-height: 1.1; /* 减小行高 */
  }

  .stat-detail {
    margin-top: 6px; /* 减小详情标签上边距 */
    font-size: 11px; /* 减小详情字体 */
    padding: 2px 6px; /* 减小详情内边距 */
  }

  .stats-row {
    flex-direction: column;
    gap: 8px; /* 减小统计项间距 */
  }

  .stat-item {
    width: 100%;
  }

  .feature-boxes {
    flex-direction: column;
    flex-wrap: wrap;
    gap: 12px; /* 减小特性盒子间距 */
  }

  .feature-box {
    width: 100%;
    flex: none;
    padding: 16px; /* 减小内边距 */
  }

  .box-header {
    margin-bottom: 12px; /* 减小头部底部间距 */
  }

  .box-description {
    margin-bottom: 12px; /* 减小描述底部间距 */
    font-size: 13px; /* 稍微减小 */
    line-height: 1.4; /* 减小行高 */
  }

  /* 饼图响应式 - 480px以下 */
  .pie-chart {
    width: 100px; /* 减小尺寸 */
    height: 100px;
    min-width: 80px;
    min-height: 80px;
  }

  .chart-legend {
    font-size: 10px; /* 减小字体 */
    gap: 4px; /* 减小间距 */
  }

  .tree-view {
    font-size: 10px; /* 减小字体 */
    line-height: 16px; /* 减小行高 */
  }

  .comparison-table .table-row {
    grid-template-columns: 35% 15% 15% 15% 10% 10%;
    font-size: 11px; /* 减小字体 */
    gap: 6px; /* 减小间距 */
    padding: 10px 12px; /* 减小内边距 */
  }

  .comparison-table .table-row.header {
    font-size: 10px; /* 减小字体 */
    padding: 8px 12px; /* 减小内边距 */
  }

  .comparison-table .note-header {
    font-size: 10px; /* 减小字体 */
    padding: 12px; /* 减小内边距 */
  }

  .action-grid {
    grid-template-columns: 1fr;
    gap: 12px; /* 减小动作卡片间距 */
  }

  .scene-images {
    flex-direction: column;
    gap: 8px; /* 减小场景图片间距 */
  }

  .scene-image {
    height: 120px; /* 减小高度 */
  }

  /* 场景概述部分优化 */
  .scene-overview {
    padding: 16px; /* 减小内边距 */
    margin-bottom: 16px; /* 减小底部间距 */
  }

  .scene-overview-desc {
    font-size: 12px; /* 减小字体 */
    line-height: 1.4; /* 减小行高 */
  }

  /* 特性卡片容器优化 */
  .feature-cards {
    gap: 8px; /* 减小间距 */
    padding: 0 8px; /* 减小边距 */
  }

  .feature-card {
    padding: 16px 12px; /* 减小内边距 */
    min-width: 0;
  }

  .feature-icon {
    width: 36px; /* 减小图标尺寸 */
    height: 36px;
    margin-bottom: 8px; /* 减小底部间距 */
  }

  .feature-card h3 {
    font-size: 13px; /* 减小字体 */
    margin-bottom: 4px; /* 减小底部间距 */
  }

  /* 高亮框优化 */
  .intro-highlight-box {
    padding: 16px; /* 减小内边距 */
    margin-bottom: 16px; /* 减小底部间距 */
  }

  .highlight-item {
    padding: 12px; /* 减小内边距 */
  }

  .highlight-text {
    font-size: 14px; /* 减小字体 */
    margin-bottom: 8px; /* 减小底部间距 */
  }

  .highlight-item p {
    font-size: 12px; /* 减小字体 */
    line-height: 1.4; /* 减小行高 */
  }

  /* 效率部分优化 */
  .efficiency-section {
    padding: 16px; /* 减小内边距 */
    margin-bottom: 16px; /* 减小底部间距 */
  }

  .efficiency-section .section-subtitle {
    font-size: 16px; /* 减小字体 */
    margin-bottom: 8px; /* 减小底部间距 */
  }

  .efficiency-description {
    font-size: 12px; /* 减小字体 */
    line-height: 1.4; /* 减小行高 */
  }

  /* 动作集容器优化 */
  .action-set-container {
    padding: 12px; /* 减小内边距 */
  }

  .action-set-header {
    margin-bottom: 8px; /* 减小底部间距 */
  }

  .action-set-desc {
    font-size: 12px; /* 减小字体 */
    margin-bottom: 12px; /* 减小底部间距 */
  }

  .viz-box {
    min-width: 100%; /* 占满宽度 */
  }

  .viz-header {
    padding: 8px; /* 减小内边距 */
  }

  .plotly-container {
    height: 300px; /* 减小高度 */
    padding: 8px; /* 减小内边距 */
  }

  .plotly-container div[id="plotly-action-viz"] {
    min-height: 250px; /* 减小最小高度 */
  }
}

/* 2K+ 高分辨率屏幕优化 - 仅保留布局相关样式，字体由section-content专用媒体查询控制 */
@media (min-width: 2048px) {
  .stats-grid {
    flex: 1 1 260px;
    max-width: 280px;
  }

  .stat-card {
    padding: 12px;
    gap: 6px;
    min-height: 150px; /* 降低最小高度 */
    max-height: 180px; /* 限制最大高度 */
    overflow: hidden;
    width: 100%; /* 确保卡片占满容器 */
  }

  /* 2K屏幕下调整stat-value-label-wrapper */
  .stat-value-label-wrapper {
    flex-direction: row !important;
    gap: 6px;
  }

  /* 2K屏幕下stat-value-label3保持3列 */
  .stat-value-label3 {
    flex: 1 1 calc(33.333% - 4px) !important;
    max-width: calc(33.333% - 4px) !important;
    min-width: 35px !important;
  }

  /* 2K屏幕下stat-value-label保持2列 */
  .stat-value-label {
    flex: 1 1 calc(50% - 4px) !important;
    max-width: calc(50% - 4px) !important;
    min-width: 80px !important;
  }

  .stat-icon,
  .stat-icon2,
  .stat-icon3,
  .stat-icon4 {
    width: 36px;
    height: 36px;
    margin-bottom: 6px;
  }
}

/* 4K 超高分辨率屏幕优化 - 仅保留布局相关样式，字体由section-content专用媒体查询控制 */
@media (min-width: 3840px) {
  .stats-grid {
    flex: 1 1 240px;
    max-width: 260px;
  }

  .stat-card {
    padding: 10px;
    gap: 5px;
    min-height: 140px; /* 降低最小高度 */
    max-height: 170px; /* 限制最大高度 */
    overflow: hidden;
  }

  .stat-value-label-wrapper {
    flex-direction: row !important;
    gap: 4px;
  }

  /* 4K屏幕下stat-value-label3保持3列布局 */
  .stat-value-label3 {
    flex: 1 1 calc(33.333% - 3px) !important;
    max-width: calc(33.333% - 3px) !important;
    min-width: 60px !important;
  }

  /* 4K屏幕下stat-value-label保持2列 */
  .stat-value-label {
    flex: 1 1 calc(50% - 3px) !important;
    max-width: calc(50% - 3px) !important;
    min-width: 60px !important;
  }

  .stat-icon,
  .stat-icon2,
  .stat-icon3,
  .stat-icon4 {
    width: 32px;
    height: 32px;
    margin-bottom: 4px;
  }

  .stat-icon img,
  .stat-icon2 img,
  .stat-icon3 img,
  .stat-icon4 img {
    width: 16px;
    height: 16px;
  }
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}

/* 加载动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section {
  animation: fadeInUp 0.6s ease-out;
}

/* 工具类 */
.justify-between {
  justify-content: space-between;
}

.flex-row {
  display: flex;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

/* 动作集容器样式 - 从 lanhu_frame_1 移植 */
.action-set-container {
  background: #f8fafc;
  border-radius: 12px;
}

.action-set-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.action-icon {
  width: 24px;
  height: 24px;
}

.action-set-header h3 {
  font-size: 18px;
  color: #0f172a;
}

.action-set-desc {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 20px;
}

.action-visualization {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.viz-box {
  flex: 1;
  min-width: 300px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.viz-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.viz-thumbnail {
  width: 20px;
  height: 20px;
}

.viz-text {
  font-size: 12px;
  color: #2563eb;
  font-weight: 500;
  text-decoration: none;
  transition: text-decoration 0.2s ease;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}


/* 新项目简介组件样式 */
.intro-text-section {
  max-width: 864px;
  margin: 0 auto;
}

.intro-description {
  font-size: 18px;
  line-height: 29px;
  color: #475569;
  margin-bottom: 32px;
  font-weight: 400;
  text-align: justify;
  letter-spacing: 0.3px;
  word-wrap: break-word;
  white-space: pre-line;
}


/* 优化简介文字在不同屏幕下的表现 */
@media (max-width: 768px) {
  .intro-description {
    font-size: 16px;
    line-height: 26px;
    text-align: left;
  }
}

@media (max-width: 480px) {
  .intro-description {
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 24px;
  }
}

/* 核心稀缺性与总量优势 - 高亮框 */
.intro-highlight-box {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 32px;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.05);
}

.highlight-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 24px;
  text-align: center;
  font-family: 'Noto Sans SC', sans-serif;
}

.highlight-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.highlight-item {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border-left: 4px solid #2563eb;
}

.highlight-text {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
  font-family: 'Noto Sans SC', sans-serif;
}

.highlight-item p {
  font-size: 14px;
  line-height: 22px;
  color: #475569;
  margin: 0;
}

/* 统计高亮数字样式 */
.stat-highlight {
  font-weight: 800;
  color: #dc2626;
  background: #fee2e2;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.95em;
  letter-spacing: 0.3px;
}

/* 开箱即用 - 效率部分 */
.efficiency-section {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
}

.efficiency-section .section-subtitle {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
  text-align: center;
  line-height: 1.4;
}

.efficiency-description {
  font-size: 15px;
  line-height: 24px;
  color: #334155;
  text-align: center;
  margin-bottom: 20px;
}

.tagline {
  font-size: 18px;
  font-weight: 700;
  color: #2563eb;
  text-align: center;
  font-style: italic;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 2px dashed #bfdbfe;
  margin-top: 16px;
}

/* Plotly 可视化容器样式 */
.plotly-container {
  width: 100%;
  height: 500px;
  background: white;
  padding: 16px;
  border-radius: 0 0 8px 8px;
}

.plotly-container div[id="plotly-action-viz"] {
  width: 100% !important;
  height: 100% !important;
  min-height: 450px;
}

/* 响应式设计 - Plotly */
@media (max-width: 768px) {
  .plotly-container {
    height: 400px;
    padding: 12px;
  }

  .plotly-container div[id="plotly-action-viz"] {
    min-height: 350px;
  }
}

@media (max-width: 480px) {
  .plotly-container {
    height: 350px;
    padding: 8px;
  }

  .plotly-container div[id="plotly-action-viz"] {
    min-height: 300px;
  }

  /* 新项目简介组件响应式设计 */
  .intro-highlight-box {
    padding: 20px;
    margin-bottom: 24px;
  }

  .highlight-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .highlight-item {
    padding: 16px;
  }

  .highlight-text {
    font-size: 15px;
  }

  .efficiency-section {
    padding: 20px;
    margin-bottom: 20px;
  }

  .efficiency-section .section-subtitle {
    font-size: 18px;
  }

  .efficiency-description {
    font-size: 14px;
  }

  .tagline {
    font-size: 16px;
    padding: 12px;
  }
}

/* 中等屏幕响应式 */
@media (max-width: 768px) {
  .intro-highlight-box {
    padding: 24px;
  }

  .highlight-title {
    font-size: 22px;
  }

  .efficiency-section {
    padding: 24px;
  }
}

/* 视频加载中覆盖层样式 */
.video-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 500;
  z-index: 10;
  backdrop-filter: blur(2px);
}

/* 隐藏加载覆盖层 */
.video-loading-overlay.hidden {
  display: none !important;
}

/* 预览占位容器 - 确保覆盖层正确定位 */
.preview-placeholder {
  position: relative;
  overflow: hidden;
}

/* 移动端适配 - 视频加载覆盖层 */
@media (max-width: 768px) {
  .video-loading-overlay {
    font-size: 12px;
    padding: 10px;
  }
}

/* 小屏幕适配 - 视频加载覆盖层 */
@media (max-width: 480px) {
  .video-loading-overlay {
    font-size: 11px;
  }
}

/* 底部重点标语响应式适配 */
@media (max-width: 768px) {
  .hero-subtitle.bottom {
    margin-top: 16px;
    width: 75%;
  }

  .hero-subtitle.bottom .feature-tagline {
    font-size: 16px;
    padding: 10px 14px;
    letter-spacing: 0.8px;
  }
}

@media (max-width: 480px) {
  .hero-subtitle.bottom .feature-tagline {
    font-size: 14px;
    padding: 8px 12px;
    letter-spacing: 0.5px;
    line-height: 1.5;
  }
}

@media (max-width: 375px) {
  .hero-subtitle.bottom .feature-tagline {
    font-size: 13px;
    padding: 6px 10px;
    letter-spacing: 0.3px;
  }
}

.navbar-item:hover,
.navbar-item.active {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.navbar-btn-sales {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: #ffffff;
  border: none;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Noto Sans SC', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.navbar-btn-sales:hover {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.5);
  transform: translateY(-1px);
}

.navbar-btn-lang {
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Noto Sans SC', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 8px;
}

.navbar-btn-lang:hover {
  background: #ffffff;
  color: #0a1929;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

/* 联系我们弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.modal-overlay.modal-active {
  opacity: 1;
  visibility: visible;
}

.modal-content {
  background: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  transform: scale(0.9);
  transition: all 0.3s ease;
}

.modal-overlay.modal-active .modal-content {
  transform: scale(1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 32px;
  color: #64748b;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #0f172a;
}

.modal-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
  font-weight: 500;
}

.label-icon {
  font-size: 16px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #0f172a;
  transition: all 0.2s;
  outline: none;
}

.form-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-input::placeholder {
  color: #94a3b8;
}

.radio-group {
  display: flex;
  gap: 24px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #0f172a;
}

.radio-item input[type="radio"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #2563eb;
}

.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #0f172a;
  transition: all 0.2s;
  outline: none;
  resize: vertical;
  font-family: inherit;
  background: #f9fafb;
}

.form-textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-textarea::placeholder {
  color: #94a3b8;
}

.submit-btn {
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
}

.submit-btn:hover {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.5);
  transform: translateY(-1px);
}

.submit-btn:active {
  transform: translateY(0);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  to {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
}

.submit-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.submit-btn:active {
  transform: translateY(0);
}

.submit-image-wrapper {
  text-align: center;
  margin-bottom: 16px;
}

.submit-image {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  cursor: pointer;
  transition: transform 0.3s;
}

.submit-image:hover {
  transform: scale(1.05);
}

.modal-image-wrapper {
  text-align: center;
  padding: 16px 24px 0;
}

.modal-image {
  max-width: 120px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.modal-overlay.modal-active .modal-content {
  transform: scale(1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-overlay.modal-active .modal-content {
  transform: scale(1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.modal-image {
  width: 150px;
  height: 150px;
  object-fit: contain;
}

@keyframes slideUp {
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  to {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
}

/* 右侧悬浮栏样式 */
.floating-sidebar {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 999999 !important;
  pointer-events: auto !important;
}

.sidebar-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 80px;
  background: #dc2626;
  cursor: pointer;
  transition: all 0.3s;
  pointer-events: auto !important;
  overflow: visible !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.sidebar-item-email {
  border-radius: 50px;
}

.sidebar-item:hover {
  background: #ef4444;
}

.sidebar-divider {
  width: 72px;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
}

.sidebar-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
  margin-bottom: 4px;
  pointer-events: none;
}

.sidebar-label {
  font-size: 12px;
  color: #ffffff;
  font-weight: 500;
  pointer-events: none;
}

.sidebar-tooltip {
  position: absolute;
  right: 82px;
  top: 50%;
  transform: translateY(-50%);
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  z-index: 1000000 !important;
  pointer-events: auto !important;
  opacity: 1 !important;
  visibility: visible !important;
  display: block !important;
  white-space: nowrap;
}

.sidebar-tooltip::before {
  content: '';
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  border: 8px solid transparent;
  border-left-color: #ffffff;
}

.tooltip-content {
  padding: 16px;
  text-align: center;
  display: block;
}

.tooltip-qr-wrapper {
  background: #f3f4f6;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  display: block;
}

.tooltip-qr {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: contain;
}

.tooltip-hint {
  font-size: 13px;
  color: #1f2937;
  font-weight: 500;
  margin-top: 8px;
  display: block;
}

.tooltip-email-content {
  padding: 16px;
  text-align: center;
  display: block;
}

.tooltip-qr-small {
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto 8px;
  object-fit: contain;
}

.email-tooltip {
  padding: 12px 16px;
}

.tooltip-email {
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
  white-space: nowrap;
}

/* 飞书二维码预览弹窗 */
.feishu-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.feishu-preview-overlay.feishu-preview-active {
  opacity: 1;
  visibility: visible;
}

.feishu-preview-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  transform: scale(0.8);
  transition: all 0.3s ease;
}

.feishu-preview-overlay.feishu-preview-active .feishu-preview-content {
  transform: scale(1);
}

.feishu-preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 36px;
  height: 36px;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #1f2937;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.feishu-preview-close:hover {
  background: #f3f4f6;
  transform: scale(1.1);
}

.feishu-preview-image {
  width: 400px;
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}
</style>
